import React, { useEffect, useState } from "react";
import "../styles/Sesion.css";
import "../styles/stylesDriver.css";
import Login from "./Login";
import { arreglarTiempoEstandar, calcularPuntosWorldAquatics, revisarUrl } from '../controllers/pdfs';
import Registrar from "./Registrar";
import { motion } from "framer-motion";
import { FcApproval, FcHighPriority } from "react-icons/fc";
import Panel from "./Panel";
import { Dialog } from 'primereact/dialog';
import { cancelarOpiniones, cancelarSuscripcionTraerClubes, cancelarTiemposResultadosFamilia, cerrarSesionFamilia, loginGoogle, puntosEstablecidos10CarrilesFecna, puntosEstablecidos8CarrilesFecna, puntosRelevosEstablecidos10CarrilesFecna, puntosRelevosEstablecidos8CarrilesFecna, registrarOpinion, registrarReaccion, registrarVisualizaciones, sacarMedalleriaTrofeoClub, sacarMedalleriaTrofeoDepartamento, sacarPuntosClub, traerClubes, traerOpiniones, traerReacciones, traerResultadosFamilia, traerTitulosTorneosFamilia, eliminarOpinion, cancelarRecordsEvento, traerRecordsEvento, traerDeportistas, traerProgramacionRegistrada, traerInformacionTorneoParaFamilias, loginGoogleAutomatico, traerInformacionUsuarioFamilia, cancelarInfoFamilia, traerInformacionPagoFamilia, traerRecords, traerEstadosCronometros } from "../controllers/configuracionFirebase";
import { InputText } from "primereact/inputtext";
import { getCookieReaccion, setReaccionCookie } from "../controllers/cookies";
import { Link, useLocation } from "react-router-dom";
import { Button } from "primereact/button";
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TabPanel, TabView } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Checkbox } from "primereact/checkbox";
import { datosAdmin, departamentosColombia, gruposCategorias, pruebasRecords } from "../controllers/administrador";
import { Tag } from "primereact/tag";
import { Rating } from "primereact/rating";
import { Avatar } from "primereact/avatar";
import toast from "react-hot-toast";
import { Sidebar } from "primereact/sidebar";
import { genAI } from "../controllers/ai";
import { ToggleButton } from "primereact/togglebutton";
import { Chip } from "primereact/chip";
import { anioAutor } from "../controllers/tiempoLimiteInscripcion";
import { driver } from "driver.js";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import CronometroExterno from "./CronometroExterno";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Sesion = ({ usuario, usuarioFamilia, fechaGoogle }) => {
  /* este estado nos ayudara a saber si se va registrar o iniciar sesion. */
  const [ datosCronometros, setDatosCronometros ] = useState({});
  const [ prueba, setPrueba ] = useState(1);
  const [ serie, setSerie] = useState(1);
  const [ segundos, setSegundos ] = useState(0);
  const [ contadorAutomatizado, setContadorAutomatizado ] = useState(0);
  const [ cronosStart, setCronosStart ] = useState(false);
  const [ posiciones, setPosiciones ] = useState([]);
  const [ mostrarPosiciones, setMostrarPosiciones ] = useState(false);
  const [ pruebaSerieAnterior, setPruebaSerieAnterior ] = useState([]);
  const [ borrarTiempos, setBorrarTiempos ] = useState(false);
  const [ recordsMundial, setRecordsMundial ] = useState();
  const [ recordsNacional, setRecordsNacional ] = useState();
  //Marcas Mundiales
  const [ edadMarcaMundialM, setEdadMarcaMundialM ] = useState(15);
  const [ edadMarcaMundialF, setEdadMarcaMundialF ] = useState(15);
  const [ mejorMarcaTecnicaM, setMejorMarcaTecnicaM ] = useState([]);
  const [ mejorMarcaTecnicaF, setMejorMarcaTecnicaF ] = useState([]);
  const [ recordsMundialesElegidosM, setRecordsMundialesElegidosM ] = useState([]);
  const [ recordsMundialesElegidosF, setRecordsMundialesElegidosF ] = useState([]);
  const [ opcionesElegidosM, setOpcionesElegidosM ] = useState([]);
  const [ opcionesElegidosF, setOpcionesElegidosF ] = useState([]);
  //Marcas Nacionales
  const [ edadMarcaNacionalM, setEdadMarcaNacionalM ] = useState(15);
  const [ edadMarcaNacionalF, setEdadMarcaNacionalF ] = useState(15);
  const [ mejorMarcaTecnicaNacionalM, setMejorMarcaTecnicaNacionalM ] = useState([]);
  const [ mejorMarcaTecnicaNacionalF, setMejorMarcaTecnicaNacionalF ] = useState([]);
  const [ recordsNacionalesElegidosM, setRecordsNacionalesElegidosM ] = useState([]);
  const [ recordsNacionalesElegidosF, setRecordsNacionalesElegidosF ] = useState([]);
  const [ opcionesNacionalesElegidosM, setOpcionesNacionalesElegidosM ] = useState([]);
  const [ opcionesNacionalesElegidosF, setOpcionesNacionalesElegidosF ] = useState([]);

  const [ infoFamilia, setInfoFamilia ] = useState();
  const [ activeIndexTab, setActiveIndexTab ] = useState(0);
  const [ visibleCountPrograma, setVisibleCountPrograma ] = useState(1);
  const [ visibleCount, setVisibleCount ] = useState(1);
  const [ login, setLogin ] = useState(true);
  const [ clubes, setClubes ] = useState([]);
  const [ deportistas, setDeportistas ] = useState([]);
  const [ expandedRowsContabilidad, setExpandedRowsContabilidad ] = useState(null);
  const [ dialogResultados, setDialogResultados ] = useState(false);
  const [ dialogHistorial, setDialogHistorial ] = useState(false);
  const [ seguimiento, setSeguimiento ] = useState(false);
  const [ evento, setEvento ] = useState();
  const [ eventoPagado, setEventoPagado ] = useState(false);
  const [ fechaUltimoPago, setFechaUltimoPago ] = useState('0000-00-00');
  const [ estrellas, setEstrellas ] = useState(null);
  const [ opiniones, setOpiniones ] = useState([]);
  const [ calificacionGeneral, setCalificacionGeneral ] = useState();
  const [ dialogHistorialEquipo, setDialogHistorialEquipo ] = useState(false);
  const [ historialDeportista, setHistorialDeportista ] = useState();
  const [ historialEquipo, setHistorialEquipo ] = useState();
  const [ resultados, setResultados ] = useState([]);
  const [ recordsEvento, setRecordsEvento ] = useState([]);
  const [ deportistasMasCompletos, setDeportistasMasCompletos ] = useState([]);
  const [ seriesSeparadas, setSeriesSeparadas ] = useState([]);
  const [ numeroCarriles, setNumeroCarriles ] = useState(0);
  const [ carrilInicio, setCarrilInicio ] = useState(0);
  const [ carrilFin, setCarrilFin ] = useState(0);
  const [ puntuar, setPuntuar ] = useState('no');
  const [ piscina, setPiscina ] = useState('');
  const [ usoSistemaCronos, setUsoSistemaCronos ] = useState(false);
  const [ trofeoClubes, setTrofeoClubes ] = useState([]);
  const [ trofeoPuntosClubes, setTrofeoPuntosClubes ] = useState([]);
  const [ trofeoDepartamentos, setTrofeoDepartamentos ] = useState([]);
  const [ titulosTorneos, setTitulosTorneos ] = useState([]);
  const [ categoriasDisponibles, setCategoriasDisponibles ] = useState([]);
  const [ categoriasElegidas, setCategoriasElegidas ] = useState([]);
  const [ categoriasPuntosClubElegidas, setCategoriasPuntosClubElegidas ] = useState([]);
  const [ globalFilter, setGlobalFilter ] = useState('');
  const [ cantPuestos, setCantPuestos ] = useState('');
  const [ identidad, setIdentidad ] = useState('222222222222');
  const [ nombreClub, setNombreClub ] = useState('');
  const [ nombresClubs, setNombresClubs ] = useState('');
  const [ reacciones, setReacciones ] = useState();
  const [ contadorQueryQr, setContadorQueryQr ] = useState(0);
  const [ animateList, setAnimateList ] = useState(false);
  const [ visibleRight, setVisibleRight ] = useState(false);
  const [ visibleLeft, setVisibleLeft ] = useState(false);
  const [ messageEspera, setMessageEspera ] = useState(false);
  const [ messages, setMessages ] = useState([
    {
      role: "user",
      parts: [{ text: "" }],
    },
    {
      role: "model",
      parts: [{ text: "¡Hola! Soy Bolt, la mascota de PROWEBSPORTS 😊 Puedo ayudarte a consultar tus tiempos, medallas ganadas, trofeos y más. ¡Solo escribe tu pregunta! 🖥️🏆" }],
    },
  ]);
  const [ steps, setSteps ] = useState([]);
  const [ programacion, setProgramacion ] = useState([]); 
  const [ urlProgramacion, setUrlProgramacion ] = useState();
  const [ urlResultados, setUrlResultados ] = useState();
  const resultadosRef = React.useRef(resultados);
  const deportistasRef = React.useRef();
  const query = useQuery();
  const valorCOP = "$3.800";
  const pruebaActual = programacion.find(pro => pro.id === parseInt(prueba));
 
  const driverObj = driver({
    popoverClass: 'driverjs-theme',
    animate: true,
    prevBtnText: 'Atras',
    nextBtnText: 'Siguiente',
    doneBtnText: 'Fin',
    steps
  });

  const stepsTour1 = [
    { popover: { title: '¡Bienvenido!', description: 'Te mostraré cómo usar esta sección. Si no deseas ver la guía, simplemente haz clic fuera de esta ventana para cerrarla', side: "top", align: 'start' }},
    { element: '.paso1', popover: { title: 'Iniciar Sesión', description: 'Los entrenadores que deseen participar y ya tengan una cuenta en PROWEBSPORTS pueden iniciar sesión con su correo y contraseña haciendo clic aquí', side: "top", align: 'start' }},
    { element: '.paso2', popover: { title: 'Resultados en tiempo real', description: `En este botón encontrarás los resultados en tiempo real de los eventos organizados por el equipo ${datosAdmin.nombre}`, side: "top", align: 'start' }},
    { element: '.paso3', popover: { title: 'Crear una cuenta', description: '¿Eres entrenador y quieres participar? Regístrate aquí, solo si aún no tienes una cuenta. Tu nueva cuenta funcionará en todo el ecosistema PROWEBSPORTS.', side: "top", align: 'start' }},
    { element: '.paso4', popover: { title: 'Verificación correo', description: 'Al crear una cuenta. La plataforma enviará un correo de verificación; debes ir a tu correo y confirmar la cuenta. Si no verificas el correo, no podrás iniciar sesión', side: "top", align: 'start' }},
  ]

  const stepsTour2 = [
    { popover: { title: '¡Bienvenido!', description: 'Te mostraré cómo usar esta sección. Aquí verás los resultados actualizándose en tiempo real. Si no quieres seguir con la guía, simplemente haz clic por fuera de esta ventana para salir', side: "bottom", align: 'start' }},
    { element: '.paso1Result', popover: { title: 'Evento', description: 'Elige el evento para ver sus resultados en tiempo real. No necesitas recargar la plataforma; se actualiza automáticamente a medida que se registran los tiempos. Si no seleccionas un evento, no podrás ver sus resultados.', side: "bottom", align: 'start' }},
    { element: '.paso2Result', popover: { title: 'Pruebas específicas', description: `Elige una prueba específica si deseas ver únicamente los resultados de esa prueba.`, side: "top", align: 'start' }},
    { element: '.paso3Result', popover: { title: 'Pruebas específicas', description: 'Aquí puedes escribir el número de la prueba para visualizar únicamente los resultados correspondientes a esa prueba.', side: "top", align: 'start' }},
    { element: '.paso4Result', popover: { title: 'Puestos', description: 'Escribe aquí cuántos puestos quieres mostrar en los resultados.', side: "top", align: 'start' }},
    { element: '.paso5Result', popover: { title: 'Deportista', description: 'Puedes digitar la tarjeta de identidad del deportista y el sistema resaltará su registro para que lo encuentres más fácilmente.', side: "top", align: 'start' }},
    { element: '.paso6Result', popover: { title: 'Equipos inscritos', description: 'Elige el nombre del equipo y el sistema resaltará a todos los deportistas de ese equipo para facilitar su visualización.', side: "top", align: 'start' }},
    { element: '.paso7Result', popover: { title: 'PROWEBSPORTS', description: 'Puedes dejarnos tu reacción: si te encanta, te gusta o te disgusta nuestra plataforma.', side: "top", align: 'start' }},
    { popover: { title: 'Iniciar Sesion', description: 'Si no has iniciado sesión con Google, te recomendamos hacerlo. Así podrás ver más información del evento, incluyendo el uso de servicios como la IA Bolt.', side: "bottom", align: 'start' }},
  ]

  const handleSend = () => {
    const mensaje = document.getElementById('preguntame').value;
    if (mensaje.trim()) {
      setMessageEspera(true);
      chatbot(mensaje);
    }
  };

  const isIOS = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    return isIOS;
  }

  const pagar = async () => {
    const auxCreando = toast.loading('Creando link de pago...\nPor favor espera unos segundos.');
    const response = await fetch("https://linkpago-oskzzvylmq-uc.a.run.app", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        idUser: usuarioFamilia.id,
        idEvento: evento,
        fecha: new Date(fechaGoogle).toISOString().split('T')[0],
        valorCOP: 3800,
        email: usuarioFamilia.email,
        sitio: datosAdmin.enlace,
        name: titulosTorneos.find(titulo => titulo.idTorneo === evento).titulo + ' - ' + datosAdmin.nombre,
        description: "Acceso exclusivo a resultados en tiempo real."
      })
    });

    const data = await response.json();
    toast.dismiss(auxCreando);
    toast.success('Link creado correctamente.');
    window.location.href = data.link;
  };

  async function chatbot(text) {
    try {
      const auxResultados = resultados;
      auxResultados.forEach((result)=>{
        result.numeroPrueba = result.id + 1;
      })

      const model = genAI.getGenerativeModel({ 
        model: "gemini-2.5-flash",
        systemInstruction: `
        no debes mostrarle al usuario los atributos del json.
        si te preguntan "ej: la prueba x" hace referencia al numero de la prueba.
        si el tiempo es 0:0:0 es por que el deportista no se presento.
        si el tiempo es 61:0:0 es por que el deportista fue descalificado.
        no debes responder que le vas a restar 1 al numero de prueba que te dan para obtener el id ojo con eso,
        no debes darle los tiempos si quedo es 0:0:0 o 61:0:0.
        no debes dar numero de identificacion a nadie que te lo pregunte por privacidad.
        ln es carril.
        sr es la serie.
        los circulos de colores son solo diseño.
        nsp significa que no se presento.
        dsc significa descalificado.
        si un club no aparece con medallas debes decir 0 medallas.
        si te preguntan medallas ganas de un deportista debe buscar en las pruebas.
        si te preguntan por medallas de un club debes buscar en trofeo medallas.
        si te preguntan por puntos de un club debes buscar en trofeo puntos.
        si te preguntan por los deportistas mas completos debes bucar top deportistas.
        si te preguntan por los records debes buscar en records.
        la flecha hacia arriba color rojo al lado del tiempo significa que se subio de tiempo.
        la flecha hacia abajo color verde al lado del tiempo significa que bajo el tiempo.
        el icono de la medalla de oro al lado derecho del tiempo significa la diferencia con el primero.
        siempre responde con emojis.
        no debes usar nunca asteriscos (ejemplo: **prueba 3**, eso se ve feo) para responder mensajes.
        si mejora o no el tiempo siempre dale un lindo mensaje motivacional para que siga esforzandose mas.
        pruebas: ${JSON.stringify(auxResultados)} - trofeo medallas: ${JSON.stringify(trofeoClubes)} - trofeo puntos: ${JSON.stringify(trofeoPuntosClubes)} - deportistas mas completos ${JSON.stringify(deportistasMasCompletos)} - records ${JSON.stringify(recordsEvento)} - equipos inscritos: ${JSON.stringify(clubes.filter((club) => deportistas.filter((depor)=> depor.nombreclub === club.nombreclub).length !== 0))}`,
        generationConfig: {
          maxOutputTokens: 1000,
        }
      });

      const chat = await model.startChat({
        history: messages || [],
      });

      const result = await chat.sendMessage(text);
      const history = await chat.getHistory();

      setMessages(history);
      setMessageEspera(false);
      document.getElementById('preguntame').value = "";
    } catch (error) {
      console.error("Error al obtener la respuesta: ", error);
    }
  }

  function manejoRendimiento(record, tiempo){
    if(tiempo && record && record !== '0:0:0' && tiempo !== '0:0:0'){
      const dividirTiempoA = record.split(':');
      const dividirTiempoB = tiempo.split(':');
      const tiempoMinA = dividirTiempoA[0];
      const tiempoSegA = dividirTiempoA[1];
      const tiempoMiliA = dividirTiempoA[2];
      const tiempoMinB = dividirTiempoB[0];
      const tiempoSegB = dividirTiempoB[1];
      const tiempoMiliB = dividirTiempoB[2];
      const tiempoA = parseInt(tiempoMinA) * 60 * 1000 + parseInt(tiempoSegA) * 1000 + parseInt(tiempoMiliA);
      const tiempoB = parseInt(tiempoMinB) * 60 * 1000 + parseInt(tiempoSegB) * 1000 + parseInt(tiempoMiliB);

      const resultadoRecords = parseFloat((tiempoA - tiempoB));
      
      return resultadoRecords;
    }else{
      return 0;
    }
  }

  function arreglarFormatoTiempo(resultadoRecords){
    const auxResultadoRecords = Math.abs(resultadoRecords);
    const minutos = Math.floor(auxResultadoRecords / (60 * 1000));
    const segundos = Math.floor((auxResultadoRecords % (60 * 1000)) / 1000);
    const milisegundos = auxResultadoRecords % 1000;
    if(minutos !== 0){
      return minutos + ':' + segundos + '.' + milisegundos;
    }else{
      return segundos + '.' + milisegundos;
    }
  }

  function arreglarFecha(fecha){
    const fechaActualizada = new Date(fecha).toLocaleString('es-ES',{ 
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      weekday: 'long'
    });
    return fechaActualizada;
  }

  async function sacarHistorialEquipo(club){
    setDialogHistorialEquipo(true);
    const identificaciones = {};
    const auxDeportistas = [];
    club.deportistas = [];
    resultados.forEach((result)=>{
      result.nadadores.forEach((nadad)=>{
        if(nadad.nombreclub === club.club && !nadad.equipo){
          if(!identificaciones[nadad.identificacion]){
            identificaciones[nadad.identificacion] = nadad.identificacion;
            auxDeportistas.push(nadad);
          }
        }
      })
    })

    for(const nad of auxDeportistas){
      const auxHistorial = [];
      if(await revisarUrl(nad.urlPhoto)){
        nad.urlPhoto = nad.urlPhoto;
      }else{
        nad.urlPhoto = '';
      }
      if(await revisarUrl(nad.urlPhotoEq)){
        nad.urlPhotoEq = nad.urlPhotoEq;
      }else{
        nad.urlPhotoEq = require('../img/img-logo-swimmingt.webp');
      }
      resultados.forEach((result)=>{
        const objHistorial = {};
        result.nadadores.forEach((nadad, indexNadad)=>{
          if(nadad.identificacion === nad.identificacion && !nadad.equipo){
            objHistorial.puesto = nadad.tiempo !== '61:0:0' ? nadad.tiempo !== '0:0:0' ? nadad.posicion : 'NSP' : 'DSC';
            objHistorial.nPrueba = result.id + 1;
            objHistorial.prueba = result.prueba.prueba;
            objHistorial.record = nadad.equipo === null ? nadad.record !== '' ? nadad.record : '0:0:0' : '0:0:0';
            objHistorial.tiempo = nadad.tiempo;
            objHistorial.verificado = nadad.verificado;
            objHistorial.puntos = result.nadadores.length === 1 && puntuar === 'no' ? 0 : parseInt(numeroCarriles) <= 8 ? puntosEstablecidos8CarrilesFecna(0, nadad.posicion - 1) : puntosEstablecidos10CarrilesFecna(0, nadad.posicion - 1);
            objHistorial.puntosWA = calcularPuntosWorldAquatics(nadad.tiempo, nadad.genero, result.prueba.prueba, piscina);
            auxHistorial.push(objHistorial);
          }
  
          if(nadad.equipo){
            const auxNombre = nadad.equipo.filter((eq) => {return eq === nad.nombre});
            if(auxNombre.length !== 0){
              objHistorial.puesto = nadad.tiempo !== '61:0:0' ? nadad.tiempo !== '0:0:0' ? nadad.posicion : 'NSP' : 'DSC';
              objHistorial.nPrueba = result.id + 1;
              objHistorial.prueba = result.prueba.prueba;
              objHistorial.record = nadad.equipo === null ? nadad.record !== '' ? nadad.record : '0:0:0' : '0:0:0';
              objHistorial.tiempo = nadad.tiempo;
              objHistorial.puntos = result.nadadores.length === 1 && puntuar === 'no' ? 0 : parseInt(numeroCarriles) <= 8 ? puntosRelevosEstablecidos8CarrilesFecna(0, nadad.posicion - 1) : puntosRelevosEstablecidos10CarrilesFecna(0, nadad.posicion - 1);
              objHistorial.puntosWA = '0';
              auxHistorial.push(objHistorial);
            }
          }
        })
      })
      nad.pruebas = [...auxHistorial];

      club.deportistas.push(nad);
    }
    setHistorialEquipo(club);
  }

  async function sacarHistorialDeportista(nad){
    setDialogHistorial(true);
    const auxHistorial = [];
    if(await revisarUrl(nad.urlPhoto)){
      nad.urlPhoto = nad.urlPhoto;
    }else{
      nad.urlPhoto = '';
    }
    if(await revisarUrl(nad.urlPhotoEq)){
      nad.urlPhotoEq = nad.urlPhotoEq;
    }else{
      nad.urlPhotoEq = require('../img/img-logo-swimmingt.webp');
    }
    resultados.forEach((result)=>{
      const objHistorial = {};
      result.nadadores.forEach((nadad, indexNadad)=>{
        if(nadad.identificacion === nad.identificacion && !nadad.equipo){
          objHistorial.puesto = nadad.tiempo !== '61:0:0' ? nadad.tiempo !== '0:0:0' ? nadad.posicion : 'NSP' : 'DSC';
          objHistorial.nPrueba = result.id + 1;
          objHistorial.prueba = result.prueba.prueba;
          objHistorial.record = nadad.equipo === null ? nadad.record !== '' ? nadad.record : '0:0:0' : '0:0:0';
          objHistorial.tiempo = nadad.tiempo;
          objHistorial.verificado = nadad.verificado;
          objHistorial.puntos = result.nadadores.length === 1 && puntuar === 'no' ? 0 : parseInt(numeroCarriles) <= 8 ? puntosEstablecidos8CarrilesFecna(0, nadad.posicion - 1) : puntosEstablecidos10CarrilesFecna(0, nadad.posicion - 1);
          objHistorial.puntosWA = calcularPuntosWorldAquatics(nadad.tiempo, nadad.genero, result.prueba.prueba, piscina);
          auxHistorial.push(objHistorial);
        }

        if(nadad.equipo){
          const auxNombre = nadad.equipo.filter((eq) => {return eq === nad.nombre});
          if(auxNombre.length !== 0){
            objHistorial.puesto = nadad.tiempo !== '61:0:0' ? nadad.tiempo !== '0:0:0' ? nadad.posicion : 'NSP' : 'DSC';
            objHistorial.nPrueba = result.id + 1;
            objHistorial.prueba = result.prueba.prueba;
            objHistorial.record = nadad.equipo === null ? nadad.record !== '' ? nadad.record : '0:0:0' : '0:0:0';
            objHistorial.tiempo = nadad.tiempo;
            objHistorial.puntos = result.nadadores.length === 1 && puntuar === 'no' ? 0 : parseInt(numeroCarriles) <= 8 ? puntosRelevosEstablecidos8CarrilesFecna(0, nadad.posicion - 1) : puntosRelevosEstablecidos10CarrilesFecna(0, nadad.posicion - 1);
            objHistorial.puntosWA = '0';
            auxHistorial.push(objHistorial);
          }
        }
      })
    })
    nad.pruebas = [...auxHistorial];
    setHistorialDeportista(nad);
  }

  function sacarMarcasMundialesMElegidas(e){
    let auxMarcasElegidas = [...recordsMundialesElegidosM];
    let auxOpcionesElegidas = [...opcionesElegidosM];
    
    if(e.checked){
      const objMarca = {
        prueba: e.value,
        record: recordsMundial.find(rem => rem.genero === 'Masculino' && rem.prueba === e.value)?.record
      }
      auxMarcasElegidas.push(objMarca);
      auxOpcionesElegidas.push(e.value);
    }else{
      auxMarcasElegidas.splice(auxOpcionesElegidas.indexOf(e.value), 1);
      auxOpcionesElegidas.splice(auxOpcionesElegidas.indexOf(e.value), 1);
    }
    setRecordsMundialesElegidosM(auxMarcasElegidas);
    setOpcionesElegidosM(auxOpcionesElegidas);
  }

  function sacarMarcasMundialesFElegidas(e){
    let auxMarcasElegidas = [...recordsMundialesElegidosF];
    let auxOpcionesElegidas = [...opcionesElegidosF];

    if(e.checked){
      const objMarca = {
        prueba: e.value,
        record: recordsMundial.find(rem => rem.genero === 'Femenino' && rem.prueba === e.value)?.record
      }
      auxMarcasElegidas.push(objMarca);
      auxOpcionesElegidas.push(e.value);
    }else{
      auxMarcasElegidas.splice(auxOpcionesElegidas.indexOf(e.value), 1);
      auxOpcionesElegidas.splice(auxOpcionesElegidas.indexOf(e.value), 1);
    }
    setRecordsMundialesElegidosF(auxMarcasElegidas);
    setOpcionesElegidosF(auxOpcionesElegidas);
  }

  function sacarMarcasNacionalesMElegidas(e){
    let auxMarcasElegidas = [...recordsNacionalesElegidosM];
    let auxOpcionesElegidas = [...opcionesNacionalesElegidosM];

    if(e.checked){
      const objMarca = {
        prueba: e.value,
        record: recordsNacional.find(rem => rem.genero === 'Masculino' && rem.prueba === e.value)?.record
      }
      auxMarcasElegidas.push(objMarca);
      auxOpcionesElegidas.push(e.value);
    }else{
      auxMarcasElegidas.splice(auxOpcionesElegidas.indexOf(e.value), 1);
      auxOpcionesElegidas.splice(auxOpcionesElegidas.indexOf(e.value), 1);
    }
    setRecordsNacionalesElegidosM(auxMarcasElegidas);
    setOpcionesNacionalesElegidosM(auxOpcionesElegidas);
  }

  function sacarMarcasNacionalesFElegidas(e){
    let auxMarcasElegidas = [...recordsNacionalesElegidosF];
    let auxOpcionesElegidas = [...opcionesNacionalesElegidosF];

    if(e.checked){
      const objMarca = {
        prueba: e.value,
        record: recordsNacional.find(rem => rem.genero === 'Femenino' && rem.prueba === e.value)?.record
      }
      auxMarcasElegidas.push(objMarca);
      auxOpcionesElegidas.push(e.value);
    }else{
      auxMarcasElegidas.splice(auxOpcionesElegidas.indexOf(e.value), 1);
      auxOpcionesElegidas.splice(auxOpcionesElegidas.indexOf(e.value), 1);
    }
    setRecordsNacionalesElegidosF(auxMarcasElegidas);
    setOpcionesNacionalesElegidosF(auxOpcionesElegidas);
  }

  function onClicReaccion(reaccion){
    if(reacciones){
      if(getCookieReaccion('reaxx') !== reaccion){
        if(getCookieReaccion('reaxx') !== ''){
          reacciones[getCookieReaccion('reaxx')] = `${parseInt(reacciones[getCookieReaccion('reaxx')]) - 1}`; 
          reacciones[reaccion] = `${parseInt(reacciones[reaccion]) + 1}`;
        }else{
          reacciones[reaccion] = `${parseInt(reacciones[reaccion]) + 1}`; 
        }
        registrarReaccion(reacciones);
      }
      setReaccionCookie('reaxx', reaccion);
    }
  }

  async function onClicTituloTorneo(){
    const idTorneo = document.getElementById('idTorneo').value;
    if(idTorneo !== ''){
      setEvento(idTorneo);
      traerClubes(idTorneo, setClubes);
      traerDeportistas(idTorneo, setDeportistas);
      traerResultadosFamilia(idTorneo, setResultados);
      traerInformacionTorneoParaFamilias(idTorneo, setNumeroCarriles, setCarrilInicio, setCarrilFin, setPuntuar, setPiscina, setUsoSistemaCronos, setUrlResultados, setUrlProgramacion);
      traerOpiniones(idTorneo, setOpiniones, setCalificacionGeneral);
      traerProgramacionRegistrada(idTorneo, setProgramacion);
      registrarVisualizaciones(idTorneo);
      if(usuarioFamilia){
        const pago = await traerInformacionPagoFamilia(usuarioFamilia.id, idTorneo);
        
        if(pago){
          setFechaUltimoPago(pago.fecha);
          setEventoPagado(true);
        }

        if(infoFamilia){
          if(infoFamilia.cuenta === 'pws'){
            setEventoPagado(true);
          }
        }
      }
    }
  }

  function formatNumeroReacciones(number) {
    if (number >= 1e6) {
      // Si es un millón o más, formatea en millones (M)
      return (number / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (number >= 1e3) {
      // Si es mil o más, formatea en miles (k)
      return (number / 1e3).toFixed(1).replace(/\.0$/, '') + 'k';
    } else {
      // Si es menos de mil, devuelve el número original
      return number.toString();
    }
  }

  function sacarDirectivos(dire){
    if(dire){
      if(dire.length !== 0){
        return <div className={`dropdown`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>
          <span className='btn btn-secondary btn-sm dropdown-toggle' id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
            Directivos {'(' + dire.length + ')'}</span>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
            {dire.map((di, indexDi)=>{
              return <li key={indexDi} className="dropdown-item">{di.nombre + ' - ' + di.rol}</li>
            })}
          </ul>
        </div>
      }
    }
  }

  const rowExpansionTemplateContabilidad = (data) => {
    return (
      <DataTable value={deportistas.filter((depor)=>depor.nombreclub === data.nombreclub)} emptyMessage="No hay deportistas inscritos aún.">
        <Column header="#" body={(_, index)=>{return index.rowIndex + 1}} style={{ width: '30px'}}></Column>
        <Column field="nombre" header="Deportista" style={{ width: '110px'}}></Column>
        <Column field="fechaNacimiento" header="Fecha Nto" style={{ width: '80px'}}></Column>
        <Column field="edad" header="Edad" style={{ width: '80px'}}></Column>
        <Column field="genero" header="Género" style={{ width: '80px'}}></Column>
      </DataTable>
    );
  };

  function sacarCategoriasElegidas(e){
    let auxCategoriasElegidas = [...categoriasElegidas];

    if(e.checked){
      auxCategoriasElegidas.push(e.value);
    }else{
      auxCategoriasElegidas.splice(auxCategoriasElegidas.indexOf(e.value), 1);
    }
    setCategoriasElegidas(auxCategoriasElegidas);
  }

  function sacarCategoriasPuntosClubElegidas(e){
    let auxCategoriasElegidas = [...categoriasPuntosClubElegidas];

    if(e.checked){
      auxCategoriasElegidas.push(e.value);
    }else{
      auxCategoriasElegidas.splice(auxCategoriasElegidas.indexOf(e.value), 1);
    }
    setCategoriasPuntosClubElegidas(auxCategoriasElegidas);
  }

  function banderas(departamento, codePais){
    const buscarBandera = departamentosColombia.filter((depBan) => {return depBan.dep === (departamento ? departamento : 'Colombia')});
    const banderaPais = departamentosColombia.filter((depBan) => {return depBan.codePais === (codePais ? codePais : 'Colombia') && depBan.pais});
    if(buscarBandera.length !== 0){
      return <div className="position-relative m-auto" style={{width: '35px'}}>
        <img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={buscarBandera[0].bandera} alt='Bandera'/>
        {banderaPais[0]?.bandera ? <img className="position-absolute bottom-0 end-0 border" style={{width: '18px'}} src={banderaPais[0]?.bandera} alt='Bandera'/> : <></>}
      </div>
    }
  }

  function calificacionYOpiniones(){
    const opinion = document.getElementById('opinion').value;
    const date = new Date(fechaGoogle);
    const fechaPc = new Date();
    // Extraer y formatear la fecha y la hora
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript son 0-11
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(fechaPc.getHours()).padStart(2, '0');
    const minutes = String(fechaPc.getMinutes()).padStart(2, '0');

    // Crear la cadena en el formato deseado
    const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

    const objOpinion = {
      id: usuarioFamilia.id,
      nombre: usuarioFamilia.nombre,
      opinion,
      estrellas: estrellas,
      fecha: formattedDateTime + ""
    }

    try {
      registrarOpinion(evento, objOpinion);
      toast.success("Gracias por ser parte del evento y compartir tu experiencia.");
      setEstrellas(null);
      document.getElementById('opinion').value = '';
    } catch (error) {
      toast.success("¡Ups! Ocurrio un error. Intentalo de nuevo.");
    }
  }

  function obtenerMensajeExperiencia(promedio) {
    if (promedio >= 4.5) return "Los asistentes tuvieron una excelente experiencia.";
    if (promedio >= 3.5) return "Los asistentes tuvieron una muy buena experiencia.";
    if (promedio >= 2.5) return "La experiencia fue regular, con puntos a mejorar.";
    if (promedio >= 1.5) return "Los asistentes tuvieron una mala experiencia.";
    return "La experiencia fue muy mala, según los asistentes.";
  }

  const onTabChange = (e) => {
    setActiveIndexTab(e.index);
    if(e.index === 0){
      setVisibleCountPrograma(1);
    }
    if(e.index >= 1 && e.index <= 2){ 
      setVisibleCount(1);
    }
  };

  useEffect(() => {
    // Comparamos los arreglos anterior y actual para detectar cambios de posición
    if (JSON.stringify(resultadosRef.current) !== JSON.stringify(resultados)) {
      // Si hay una diferencia en los arreglos, activamos la animación
      setAnimateList(true);
    }

    // Actualizamos la referencia con el nuevo estado del arreglo
    resultadosRef.current = resultados;

    function sacarCategoriasRepetidas(arr) {
      const auxCategorias = new Set();
      arr.forEach((cate)=>{
        auxCategorias.add(cate.categoria);
      })
      return Array.from(auxCategorias);
    }

    if(seguimiento && resultados.length !== 0){
      setGlobalFilter((resultados[resultados.length - 1].id + 1) + '');
    }

    function calcularDiferenciaTiempo(tiempoDeportista, recordMundial) {
      const tiempoRecord = recordMundial.split(':').map(Number);
    
      const auxTiempoDeportista = tiempoDeportista[0] * 60 * 1000 + tiempoDeportista[1] * 1000 + tiempoDeportista[2];
      const auxTiempoRecord = tiempoRecord[0] * 60 * 1000 + tiempoRecord[1] * 1000 + tiempoRecord[2];
      const diferencia = auxTiempoRecord - auxTiempoDeportista;
  
      return diferencia;
    }
    
    function mejorMarcaTecnicaMundial() {
    
      const nadadoresMasculinos = [];
      const nadadoresFemeninos = [];
    
      resultados.forEach((resul) => {
        resul.nadadores.forEach((deportista) => {
          if (resul.categoria.match(/\bM\b/g) && parseInt(deportista.edad) >= edadMarcaMundialM) {   
            const recordMundial = recordsMundialesElegidosM.find(
              (reco) => reco.prueba === resul.prueba.prueba
            );
            if (recordMundial) {
              const tiempoDeportista = deportista.tiempo.split(':').map(Number);
              const diferenciaTiempo = calcularDiferenciaTiempo(
                tiempoDeportista,
                recordMundial.record
              );
    
              if(deportista.tiempo !== '0:0:0' && deportista.tiempo !== '61:0:0'){
                nadadoresMasculinos.push({
                  nombre: deportista.nombre,
                  club: deportista.nombreclub,
                  prueba: resul.prueba.prueba,
                  identificacion: deportista.identificacion,
                  edad: deportista.edad,
                  tiempo: arreglarTiempoEstandar(deportista.tiempo),
                  mt: recordsMundial.find(rem => rem.genero === 'Masculino' && rem.prueba === resul.prueba.prueba)?.record,
                  diferencia: diferenciaTiempo,
                });
              }
            }
          }
    
          if (resul.categoria.match(/\bF\b/g) && parseInt(deportista.edad) >= edadMarcaMundialF) {
            const recordMundial = recordsMundialesElegidosF.find(
              (reco) => reco.prueba === resul.prueba.prueba
            );
            if (recordMundial) {
              const tiempoDeportista = deportista.tiempo.split(':').map(Number);
              const diferenciaTiempo = calcularDiferenciaTiempo(
                tiempoDeportista,
                recordMundial.record
              );
    
              if(deportista.tiempo !== '0:0:0' && deportista.tiempo !== '61:0:0'){
                nadadoresFemeninos.push({
                  nombre: deportista.nombre,
                  club: deportista.nombreclub,
                  prueba: resul.prueba.prueba,
                  identificacion: deportista.identificacion,
                  edad: deportista.edad,
                  tiempo: arreglarTiempoEstandar(deportista.tiempo),
                  mt: recordsMundial.find(rem => rem.genero === 'Femenino' && rem.prueba === resul.prueba.prueba)?.record,
                  diferencia: diferenciaTiempo,
                });
              }
            }
          }
        });
      });
    
      // Ordenar los nadadores por diferencia de tiempo de menor a mayor
      nadadoresMasculinos.sort((a, b) => {
        const diferenciaA = a.diferencia; 
        const diferenciaB = b.diferencia;

        if (diferenciaA >= 0 && diferenciaB >= 0) {
          const splitTiempoA = a.tiempo.split(':');
          const splitTiempoB = b.tiempo.split(':');
          const tiemposA = splitTiempoA[0] * 60 * 1000 + splitTiempoA[1] * 1000 + splitTiempoA[2];
          const tiemposB = splitTiempoB[0] * 60 * 1000 + splitTiempoB[1] * 1000 + splitTiempoB[2];
          return tiemposA - tiemposB;
        } else if (diferenciaA < 0 && diferenciaB < 0) {
          return Math.abs(diferenciaA) - Math.abs(diferenciaB);
        } else {
          return diferenciaA >= 0 ? -1 : 1;
        }
      });

      nadadoresFemeninos.sort((a, b) => {
        const diferenciaA = a.diferencia;
        const diferenciaB = b.diferencia;
            
        if (diferenciaA >= 0 && diferenciaB >= 0) {
          const splitTiempoA = a.tiempo.split(':');
          const splitTiempoB = b.tiempo.split(':');
          const tiemposA = splitTiempoA[0] * 60 * 1000 + splitTiempoA[1] * 1000 + splitTiempoA[2];
          const tiemposB = splitTiempoB[0] * 60 * 1000 + splitTiempoB[1] * 1000 + splitTiempoB[2];
          return tiemposA - tiemposB;
        } else if (diferenciaA < 0 && diferenciaB < 0) {
          return Math.abs(diferenciaA) - Math.abs(diferenciaB);
        } else {
          return diferenciaA >= 0 ? -1 : 1;
        }
      });
    
      setMejorMarcaTecnicaM(nadadoresMasculinos);
      setMejorMarcaTecnicaF(nadadoresFemeninos);
    }
    
    function mejorMarcaTecnicaNacional() {
    
      const nadadoresMasculinos = [];
      const nadadoresFemeninos = [];
    
      resultados.forEach((resul) => {
        resul.nadadores.forEach((deportista) => {
          if (resul.categoria.match(/\bM\b/g) && parseInt(deportista.edad) >= edadMarcaNacionalM) {   
            const recordNacional = recordsNacionalesElegidosM.find(
              (reco) => reco.prueba === resul.prueba.prueba
            );
            if (recordNacional) {
              const tiempoDeportista = deportista.tiempo.split(':').map(Number);
              const diferenciaTiempo = calcularDiferenciaTiempo(
                tiempoDeportista,
                recordNacional.record
              );
    
              if(deportista.tiempo !== '0:0:0' && deportista.tiempo !== '61:0:0'){
                nadadoresMasculinos.push({
                  nombre: deportista.nombre,
                  club: deportista.nombreclub,
                  prueba: resul.prueba.prueba,
                  identificacion: deportista.identificacion,
                  edad: deportista.edad,
                  tiempo: arreglarTiempoEstandar(deportista.tiempo),
                  mt: recordsNacional.find(rem => rem.genero === 'Masculino' && rem.prueba === resul.prueba.prueba)?.record,
                  diferencia: diferenciaTiempo,
                });
              }
            }
          }
    
          if (resul.categoria.match(/\bF\b/g) && parseInt(deportista.edad) >= edadMarcaNacionalF) {
            const recordNacional = recordsNacionalesElegidosF.find(
              (reco) => reco.prueba === resul.prueba.prueba
            );
            if (recordNacional) {
              const tiempoDeportista = deportista.tiempo.split(':').map(Number);
              const diferenciaTiempo = calcularDiferenciaTiempo(
                tiempoDeportista,
                recordNacional.record
              );
    
              if(deportista.tiempo !== '0:0:0' && deportista.tiempo !== '61:0:0'){
                nadadoresFemeninos.push({
                  nombre: deportista.nombre,
                  club: deportista.nombreclub,
                  prueba: resul.prueba.prueba,
                  identificacion: deportista.identificacion,
                  edad: deportista.edad,
                  tiempo: arreglarTiempoEstandar(deportista.tiempo),
                  mt: recordsNacional.find(rem => rem.genero === 'Femenino' && rem.prueba === resul.prueba.prueba)?.record,
                  diferencia: diferenciaTiempo,
                });
              }
            }
          }
        });
      });
    
      // Ordenar los nadadores por diferencia de tiempo de menor a mayor
      nadadoresMasculinos.sort((a, b) => {
        const diferenciaA = a.diferencia; 
        const diferenciaB = b.diferencia;

        if (diferenciaA >= 0 && diferenciaB >= 0) {
          const splitTiempoA = a.tiempo.split(':');
          const splitTiempoB = b.tiempo.split(':');
          const tiemposA = splitTiempoA[0] * 60 * 1000 + splitTiempoA[1] * 1000 + splitTiempoA[2];
          const tiemposB = splitTiempoB[0] * 60 * 1000 + splitTiempoB[1] * 1000 + splitTiempoB[2];
          return tiemposA - tiemposB;
        } else if (diferenciaA < 0 && diferenciaB < 0) {
          return Math.abs(diferenciaA) - Math.abs(diferenciaB);
        } else {
          return diferenciaA >= 0 ? -1 : 1;
        }
      });

      nadadoresFemeninos.sort((a, b) => {
        const diferenciaA = a.diferencia;
        const diferenciaB = b.diferencia;
            
        if (diferenciaA >= 0 && diferenciaB >= 0) {
          const splitTiempoA = a.tiempo.split(':');
          const splitTiempoB = b.tiempo.split(':');
          const tiemposA = splitTiempoA[0] * 60 * 1000 + splitTiempoA[1] * 1000 + splitTiempoA[2];
          const tiemposB = splitTiempoB[0] * 60 * 1000 + splitTiempoB[1] * 1000 + splitTiempoB[2];
          return tiemposA - tiemposB;
        } else if (diferenciaA < 0 && diferenciaB < 0) {
          return Math.abs(diferenciaA) - Math.abs(diferenciaB);
        } else {
          return diferenciaA >= 0 ? -1 : 1;
        }
      });
    
      setMejorMarcaTecnicaNacionalM(nadadoresMasculinos);
      setMejorMarcaTecnicaNacionalF(nadadoresFemeninos);
    }

    function buscarGrupoPorEdad(edad, genero) {
      return gruposCategorias.find(grupo => grupo.edades.includes(edad) && grupo.genero === genero);
    }
    
    function deportistasCompletos(){
      const auxResultados = JSON.parse(JSON.stringify(resultados));
      const auxGruposCategorias = gruposCategorias.map(grupo => {
        return {
          categoria: grupo.categoria,
          genero: grupo.genero,
          nadadores: []
        };
      });
      
      for (const resultado of auxResultados) {
        const prueba = resultado.prueba.prueba;
    
        for (const nadador of resultado.nadadores) {
          if(!nadador.equipo){
            // Buscamos a qué grupo pertenece
            const grupo = buscarGrupoPorEdad(parseInt(nadador.edad), nadador.genero);
            if (!grupo) continue;
          
            // Buscamos el grupo en el nuevo arreglo
            const grupoDestino = auxGruposCategorias.find(g => g.categoria === grupo.categoria && g.genero === grupo.genero);
          
            // Verificamos si el nadador ya fue agregado
            let nadadorExistente = grupoDestino.nadadores.find(n => n.nombre === nadador.nombre && n.edad === nadador.edad && n.genero === nadador.genero);
            
            if (!nadadorExistente) {
              // Si no está, lo agregamos con la prueba
              nadadorExistente = {
                nombre: nadador.nombre,
                edad: nadador.edad,
                genero: nadador.genero,
                departamento: nadador.departamento,
                codePais: nadador.codePais,
                nombreclub: nadador.nombreclub,
                categoria: resultado.categoria,
                grupo: grupoDestino.categoria,
                urlPhoto: nadador.urlPhoto,
                pruebas: [],
                puntos: 0
              };
              grupoDestino.nadadores.push(nadadorExistente);
            }
      
            
            // Agregamos la prueba que hizo
            nadadorExistente.pruebas.push({
              id: resultado.id,
              prueba,
              tiempo: nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : nadador.tiempo,
              posicion: nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : nadador.posicion,
              puntosPosicion: resultado.nadadores.length === 1 && puntuar === 'no' ? 0 : parseInt(numeroCarriles) <= 8 ? parseInt(puntosEstablecidos8CarrilesFecna(0, nadador.posicion - 1)) : parseInt(puntosEstablecidos10CarrilesFecna(0, nadador.posicion - 1)),
              puntosWA: calcularPuntosWorldAquatics(nadador.tiempo, nadador.genero, resultado.prueba.prueba, piscina),
              puntosNSP: nadador.tiempo === '0:0:0' ? -5 : 3,
              puntosDSC: nadador.tiempo === '61:0:0' ? -10 : 3,
              puntosPrimerLugar: nadador.posicion === 1 ? 5 : 0,
              puntos: 0
            });
      
            nadadorExistente.pruebas.forEach((nadExi)=>{
              nadExi.puntos = nadExi.puntosPosicion + nadExi.puntosWA + nadExi.puntosPrimerLugar + nadExi.puntosNSP + nadExi.puntosDSC;
            })
          }else{
            for(const eq of nadador.equipo){
              let auxDeportista = null;
              auxResultados.forEach((resul)=>{
                resul.nadadores.forEach((nad)=>{
                  if(eq === nad.nombre && !nad.equipo && nad.nombreclub === nadador.nombreclub){
                    auxDeportista = nad;
                  }
                })
              })
    
              if(auxDeportista){
                // Buscamos a qué grupo pertenece
                const grupo = buscarGrupoPorEdad(parseInt(auxDeportista.edad), auxDeportista.genero);
                if (!grupo) continue;
            
                // Buscamos el grupo en el nuevo arreglo
                const grupoDestino = auxGruposCategorias.find(g => g.categoria === grupo.categoria && g.genero === grupo.genero);
            
                // Verificamos si el nadador ya fue agregado
                let nadadorExistente = grupoDestino.nadadores.find(n => n.nombre === auxDeportista.nombre && n.edad === auxDeportista.edad && n.genero === auxDeportista.genero);
              
                if (!nadadorExistente) {
                  // Si no está, lo agregamos con la prueba
                  nadadorExistente = {
                    nombre: auxDeportista.nombre,
                    edad: auxDeportista.edad,
                    genero: auxDeportista.genero,
                    departamento: nadador.departamento,
                    codePais: nadador.codePais,
                    nombreclub: nadador.nombreclub,
                    categoria: resultado.categoria,
                    grupo: grupoDestino.categoria,
                    urlPhoto: nadador.urlPhoto,
                    pruebas: [],
                    puntos: 0
                  };
                  grupoDestino.nadadores.push(nadadorExistente);
                }
    
              
                // Agregamos la prueba que hizo
                nadadorExistente.pruebas.push({
                  id: resultado.id,
                  prueba,
                  tiempo: nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : nadador.tiempo,
                  posicion: nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : nadador.posicion,
                  puntosPosicion: resultado.nadadores.length === 1 && puntuar === 'no' ? 0 : parseInt(numeroCarriles) <= 8 ? parseInt(puntosEstablecidos8CarrilesFecna(0, nadador.posicion - 1)) : parseInt(puntosEstablecidos10CarrilesFecna(0, nadador.posicion - 1)),
                  puntosWA: calcularPuntosWorldAquatics(nadador.tiempo, auxDeportista.genero, resultado.prueba.prueba, piscina),
                  puntosNSP: nadador.tiempo === '0:0:0' ? -5 : 3,
                  puntosDSC: nadador.tiempo === '61:0:0' ? -10 : 3,
                  puntosPrimerLugar: nadador.posicion === 1 ? 5 : 0,
                  puntos: 0
                });
    
                nadadorExistente.pruebas.forEach((nadExi)=>{
                  nadExi.puntos = nadExi.puntosPosicion + nadExi.puntosWA + nadExi.puntosPrimerLugar + nadExi.puntosNSP + nadExi.puntosDSC;
                })
              }
            }
          }
        }
      }
      auxGruposCategorias.forEach((gru)=>{
        gru.nadadores.forEach((nad)=>{
          nad.pruebas.forEach((prue)=>{
            nad.puntos += prue.puntos;
          })
        })
      })
      auxGruposCategorias.map((gru)=>gru.nadadores.sort((a,b)=> b.puntos - a.puntos));
      setDeportistasMasCompletos(auxGruposCategorias);
    }

    function separareries(){
      const auxResultadosSeries = [];
      resultados.forEach((result)=>{
        const pruebas = {
          categoria: result.categoria,
          categoriaDeportistas: result.categoriaDeportistas,
          categoriaEdad: result.categoriaEdad,
          id: result.id,
          prueba: result.prueba,
          series: []
        };
        const auxSeries = [];
        result.nadadores.forEach((nad)=>{
          auxSeries[parseInt(nad.serie - 1)] = [];
        })

        result.nadadores.forEach((nad)=>{
          auxSeries[parseInt(nad.serie - 1)].push(nad);
        })

        pruebas.series = auxSeries;
        auxResultadosSeries.push(pruebas);
      })
      
      setSeriesSeparadas(auxResultadosSeries);
    }

    mejorMarcaTecnicaMundial();
    mejorMarcaTecnicaNacional();
    setCategoriasDisponibles(sacarCategoriasRepetidas(resultados));
    setTrofeoClubes(sacarMedalleriaTrofeoClub(resultados, categoriasElegidas, puntuar));
    setTrofeoPuntosClubes(sacarPuntosClub(resultados, numeroCarriles, categoriasPuntosClubElegidas, puntuar));
    setTrofeoDepartamentos(sacarMedalleriaTrofeoDepartamento(resultados, categoriasElegidas, puntuar));
    deportistasCompletos();
    separareries();
    const animationDuration = 1000; // Duración de la animación en milisegundos (aquí 0.5 segundos)
    const timer = setTimeout(() => {
      setAnimateList(false);
    }, animationDuration);
 
    return () => clearTimeout(timer);
  }, [resultadosRef, resultados, categoriasElegidas, categoriasPuntosClubElegidas, puntuar, numeroCarriles, 
    edadMarcaMundialF, edadMarcaMundialM, recordsMundialesElegidosF, recordsMundialesElegidosM, edadMarcaNacionalF, 
    edadMarcaNacionalM, recordsNacionalesElegidosF, recordsNacionalesElegidosM])

  useEffect(() =>{
    if(seguimiento){
      setGlobalFilter((resultados[resultados.length - 1].id + 1) + '');
    }else{
      setGlobalFilter('');
    }
  },[seguimiento])

  useEffect(() =>{
    if(!dialogResultados){
      cancelarTiemposResultadosFamilia();
      cancelarSuscripcionTraerClubes();
      cancelarInfoFamilia();
      cancelarOpiniones();
      setOpiniones([]);
      setResultados([]);
      setClubes([]);
      setEvento();
      setEstrellas(null);
      setCalificacionGeneral();
      setVisibleCount(1);
      setVisibleCountPrograma(1);
      cancelarRecordsEvento();
      setDeportistas([]);
      setProgramacion([]);
    }else{
      setSteps(stepsTour2);
      traerTitulosTorneosFamilia(setTitulosTorneos);
      traerRecordsEvento(setRecordsEvento);
      {usuarioFamilia && traerInformacionUsuarioFamilia(usuarioFamilia.id, setInfoFamilia)}
      setVisibleLeft(true);
    }
  },[dialogResultados, usuarioFamilia])

  useEffect(() =>{
    traerReacciones(setReacciones);
    setSteps(stepsTour1);
  },[])

  useEffect(() =>{
    if(query.get('source') === 'qr' && contadorQueryQr === 0){
      setDialogResultados(true);
      setContadorQueryQr(1);
    }
  },[usuario, query])

  useEffect(() => {
    if(usuario){
      driverObj.destroy();
    }
  },[usuario])

  useEffect(() =>{
    function sacarNombresClubes(){
      const auxNombres = new Map();
      resultados.forEach((res)=>{
        res.nadadores.forEach((nad)=>{
          const objNombres = {
            name: nad.nombreclub,
            code: nad.club
          }
          auxNombres.set(nad.nombreclub, objNombres);
        })
      })

      setNombresClubs(Array.from(auxNombres.values()));
    }

    sacarNombresClubes();
  },[resultados])

  useEffect(() => {
    if (visibleCount < resultados.length) {
      const timeout = setTimeout(() => setVisibleCount(v => v + 10), 500);
      return () => clearTimeout(timeout);
    }
  }, [visibleCount, resultados.length]);

  useEffect(() => {
    if (visibleCountPrograma < programacion.length) {
      const timeout = setTimeout(() => setVisibleCountPrograma(v => v + 10), 500);
      return () => clearTimeout(timeout);
    }
  }, [programacion.length, visibleCountPrograma]);

  useEffect(() => {
    if(!usuario){
      driverObj.destroy();
      driverObj.drive();
    }
  },[steps, usuario])

  useEffect(() =>{
    if(dialogResultados && !usuarioFamilia){
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
  
      script.onload = () => {
        window.google.accounts.id.initialize({
          client_id: "121430827570-6cmh8oshag5nus9ve5hh9tbcmnqoeck4.apps.googleusercontent.com",
          callback: loginGoogleAutomatico,
          auto_select: true,
          itp_support: true,
        });
  
        window.google.accounts.id.prompt();
      };
    }
  },[dialogResultados, usuarioFamilia])

  useEffect(() =>{
    if(piscina && piscina !== ''){
      traerRecords(setRecordsMundial, "Mundial", piscina);
      traerRecords(setRecordsNacional, "Nacional", piscina);
    }
  },[piscina])

  return usuario ? (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="bgColombia"></div> 
      <Panel usuario={usuario} fechaGoogle={fechaGoogle}/>
    </motion.div>
  ) : (
    <>
      <div className="d-flex align-items-center" style={{overflowX: 'hidden', height: '100dvh', background: 'linear-gradient(0deg,rgba(45, 161, 207, 0.3) 10%, rgba(255, 255, 255, 0.8) 50%)'}}>
        <div className="w-100">
          <ul className="circles" style={{zIndex: -10}}>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className="position-relative"
            style={{height: '100dvh'}}
          >
            {login ? (
              <Login setLogin={setLogin} setDialogResultados={setDialogResultados} />
            ):(
              <Registrar setLogin={setLogin} />
            )}
          </motion.div>
        </div>
      </div>
      <Dialog visible={dialogResultados} header="Resultados en tiempo real" modal className="p-fluid dialog-resultados p-dialog-maximized" onHide={() => setDialogResultados(false)}>
        {evento && (usoSistemaCronos ? (
         <div className="alert alert-success alert-dismissible fade show mb-0" role="alert">
            <h5 className="mb-1">Estimado/a {usuarioFamilia ? usuarioFamilia.nombre : 'Usuario'}:</h5>
            <p className="mb-0" style={{fontSize: '15px', lineHeight: 1.2}}>
              <b>No es necesario recargar la plataforma.</b> Los resultados se actualizan automáticamente en tiempo real.<br />
              Este evento <b>utiliza el sistema semiautomático de PROWEBSPORTS</b>, que agiliza la publicación de tiempos. Pueden presentarse leves demoras por la conexión a internet. Cualquier diferencia en los tiempos puede deberse a factores humanos en el cronometraje.<br />
              <b>PROWEBSPORTS garantiza el correcto funcionamiento de sus sistemas.</b></p>
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div> 
        ):(
          <div className="alert alert-warning alert-dismissible fade show mb-0" role="alert">
            <h5 className="mb-1">Estimado/a {usuarioFamilia ? usuarioFamilia.nombre : 'Usuario'}:</h5>
            <p className="mb-0" style={{fontSize: '15px', lineHeight: 1.2}}>
              <b>No es necesario recargar la plataforma.</b> Los resultados se actualizan automáticamente cuando sean ingresados al sistema.
              Este evento <b>no utiliza el sistema semiautomático</b>, por lo que los tiempos se recolectan en papeletas y luego se digitan, lo que puede generar demoras. Cualquier diferencia en los tiempos puede deberse a factores humanos en el cronometraje.<br />
              <b>PROWEBSPORTS garantiza el correcto funcionamiento de sus sistemas.</b></p>
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>
        ))}
        {usuarioFamilia && <div className="alert alert-danger alert-dismissible fade show mb-0" role="alert">
          <p className="mb-0" style={{fontSize: '15px', lineHeight: 1.2}}>Tu cuenta puede tener máximo <b>2 sesiones activas</b> en las plataformas de <b>PROWEBSPORTS</b>.
            Si deseas ingresar a otra plataforma o ver resultados de otro evento, primero deberás cerrar alguna sesión activa.</p>
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>}
        <div className="d-flex justify-content-between w-100 border" style={{background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}>
          <Button icon='pi pi-bars' className="py-2 text-light border-end" text onClick={() => setVisibleLeft(true)}/>
          <div className="d-flex">
            <div className="d-flex align-items-center me-2 text-light" title="Visualizaciones">
              {evento && <>
                <i className="pi pi-chart-bar me-1"></i>
                <p className="m-0 fw-bold me-1">{formatNumeroReacciones(parseInt(titulosTorneos.filter((ti)=> ti.idTorneo === evento)[0].visualizaciones))}</p>
              </>}
            </div>
            {resultados.length !== 0 && (
              <Button title="BOLT Resultados" icon='pi pi-microchip-ai' className="py-2 text-light border-start" text onClick={() => setVisibleRight(true)}/>
            )}
          </div>
        </div>
        <Sidebar visible={visibleLeft} position="left" onHide={() => setVisibleLeft(false)} style={{width: '305px'}}>
          <h2 className="text-center position-absolute" style={{top: '18px'}}>¡Bienvenido!</h2>
          <Link className="position-absolute" to='https://www.prowebsports.com.co/' target="_blank" style={{fontSize: '12px', textDecoration: 'none', top: '57px'}}>© 2023 - {anioAutor()} PROWEBSPORTS</Link>
          <hr className="m-0" />
          {!usuarioFamilia && (
            <ul className="navbar-nav justify-content-end flex-grow-1 text-dark mt-1">
              <li className="nav-item d-flex align-items-center paso1Result">
                <div className="form-floating">
                  <select name="idTorneo" id="idTorneo" className='form-select' onChange={() => onClicTituloTorneo()}>
                    <option value="">Elige el evento</option>
                    {titulosTorneos.length !== 0 ? (
                      titulosTorneos.map((torn,indexTorn)=>{
                        return <option key={indexTorn} value={torn.idTorneo}>{torn.titulo + ' ' + new Date(torn.fechaTorneoF).getFullYear()}</option>
                      }))
                      :(
                      <option value="">Sin eventos aún</option>
                      )
                    }
                  </select>
                  <label htmlFor="idTorneo">Eventos</label>
                </div>
              </li>
              <hr className="my-1"/>
              <li className="nav-item d-flex align-items-center paso6Result">
                <span className="p-input-icon-left w-100">
                  <i className="pi pi-users" />
                  <Dropdown className="w-100 me-2" value={nombreClub} onChange={(e) => setNombreClub(e.value)} options={nombresClubs} optionLabel="name" 
                    placeholder="Elige el equipo" />
                </span>
              </li>
            </ul>
          )}
          {!usuarioFamilia ? (
            <div className="alert alert-info alert-warning fade show m-0 p-1 shadow mt-3" role="alert">
              <p className="text-center mb-0" style={{lineHeight: 1.2}}>Accede con una cuenta de Google para habilitar funciones adicionales.</p>
              <hr className="my-1"/>
              <Button icon='pi pi-google' className="w-auto rounded-3 mx-1 p-1 px-2" label="Acceso" severity="secondary" size="small" onClick={() => loginGoogle()}></Button>
            </div>
          ):(
            <>
              <div className="d-flex justify-content-start align-items-center mt-1 position-relative">
                {(infoFamilia && infoFamilia.cuenta === 'pws') && <Tag className="position-absolute p-0 px-1" icon='pi pi-crown' severity='success' value="Cliente" style={{right: '0', bottom: 0}}></Tag>}
                {usuarioFamilia ? (
                  <Avatar className="flex align-items-center justify-content-center mr-2" image={usuarioFamilia.photo} label={usuarioFamilia.photo !== null ? '' : usuarioFamilia.nombre[0]} size="xlarge"/>
                ):(
                  <Avatar className="flex align-items-center justify-content-center mr-2" label={'A'} size="xlarge"/>
                )}
                <span className="ms-1" style={{width: '178px', overflow: 'hidden', textOverflow: 'ellipsis'}}>{usuarioFamilia ? usuarioFamilia.nombre : 'Anónimo'}</span>
                {fechaUltimoPago !== '0000-00-00' && <span className="position-absolute bottom-0" style={{fontSize: '12px', left: '68px'}}>Último pago: {fechaUltimoPago}</span>}
              </div>
              <div style={{width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '15px'}}>
                <span>{usuarioFamilia?.email}</span>
              </div>
              <hr className="my-1" />
              {(usuarioFamilia && evento) && (
                <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{duration: 1}}
                >
                  <div className="text-center d-flex flex-column justify-content-start">
                    <Rating value={estrellas} onChange={(e) => setEstrellas(e.value)} cancel={false}/>
                    <textarea id="opinion" className='form-control mt-1' rows="3" placeholder="Tu experiencia nos importa. ¿Qué opinas del evento? Agradecemos que compartas tu opinión con respeto y objetividad."></textarea>
                    {estrellas ? (
                      <Button size="small" icon="pi pi-star-fill" label={`${estrellas} Calificar`} className="btn btn-success ms-1 mt-1" style={{maxWidth: '135px'}} onClick={() => calificacionYOpiniones()}></Button>
                    ):(
                      <></>
                    )}
                  </div>
                </motion.div>
              )}
              <hr className="my-1" />
              <div className="d-flex justify-content-around paso7Result">
                {getCookieReaccion('reaxx') === 'meencanta' ? (
                  <Button className="rounded-3 bg-danger text-light border py-2" text icon='pi pi-heart-fill' size="small" label={reacciones ? formatNumeroReacciones(parseInt(reacciones.meencanta)) : '0'}/>
                ):(
                  <Button className="rounded-3 text-danger border py-2" text icon='pi pi-heart' size="small" label={reacciones ? formatNumeroReacciones(parseInt(reacciones.meencanta)) : '0'} onClick={() => onClicReaccion('meencanta')}/>
                )}
                {getCookieReaccion('reaxx') === 'like' ? (
                  <Button className="rounded-3 bg-primary text-light border py-2" text icon='pi pi-thumbs-up-fill' size="small" label={reacciones ? formatNumeroReacciones(parseInt(reacciones.like)) : '0'}/>
                ):(
                  <Button className="rounded-3 text-primary border py-2" text icon='pi pi-thumbs-up' size="small" label={reacciones ? formatNumeroReacciones(parseInt(reacciones.like)) : '0'} onClick={() => onClicReaccion('like')}/>
                )}
                {getCookieReaccion('reaxx') === 'dislike' ? (
                  <Button className="rounded-3 bg-primary text-light border py-2" text icon='pi pi-thumbs-down-fill' size="small" label={reacciones ? formatNumeroReacciones(parseInt(reacciones.dislike)) : '0'}/>
                ):(
                  <Button className="rounded-3 text-primary border py-2" text icon='pi pi-thumbs-down' size="small" label={reacciones ? formatNumeroReacciones(parseInt(reacciones.dislike)) : '0'} onClick={() => onClicReaccion('dislike')}/>
                )}
              </div>
              <hr className="my-1" />
              <ul className="navbar-nav justify-content-end flex-grow-1 text-dark">
                {!eventoPagado && (
                  <div className="alert alert-info alert-dismissible fade show m-0 p-1" role="alert">
                    <p className="text-center my-1" style={{lineHeight: 1.2}}>Por solo COP <b>{valorCOP}</b> accede a resultados y detalles exclusivos del evento. {!evento && <b><br />Elige un evento</b>}</p>
                    {(evento && usuarioFamilia) && <Button icon='pi pi-wallet' className="rounded-3 mx-1 w-auto p-1" severity="secondary" label="Wompi" size="small" onClick={() => pagar()}></Button>}
                  </div>
                )}
                {(!eventoPagado) && (
                  <hr className="my-1"/>
                )}
                <li className="nav-item d-flex align-items-center paso1Result">
                  <div className="form-floating">
                    <select name="idTorneo" id="idTorneo" className='form-select' onChange={() => onClicTituloTorneo()}>
                      <option value="">Elige el evento</option>
                      {titulosTorneos.length !== 0 ? (
                        titulosTorneos.map((torn,indexTorn)=>{
                          return <option key={indexTorn} value={torn.idTorneo}>{torn.titulo + ' ' + new Date(torn.fechaTorneoF).getFullYear()}</option>
                        }))
                        :(
                        <option value="">Sin eventos aún</option>
                        )
                      }
                    </select>
                    <label htmlFor="idTorneo">Eventos</label>
                  </div>
                </li>
                <hr className="my-1"/>
                <li className="nav-item d-flex align-items-center paso2Result">
                  <div className="form-floating w-100">
                    <select className="form-select w-100" id="pruebas" onChange={(e) => setGlobalFilter(e.target.value)}>
                      <option value="">Todas</option>
                      {resultados.length !== 0 && (
                        resultados.map((result, indexResult)=>{
                          return <option key={indexResult} value={result.id + 1}>{(result.id + 1) + ') ' + result.prueba.prueba + ' - ' + result.categoria}</option>
                        })
                      )}
                    </select>
                    <label htmlFor="pruebas">Pruebas</label>
                  </div>
                </li>
                <hr className="my-1"/>
                <li className="nav-item d-flex align-items-center paso3Result">
                  <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                      className="w-100"
                      type="number"
                      onChange={(e) => setGlobalFilter(e.target.value)}
                      placeholder="Numero de la prueba"
                    />
                  </span>
                </li>
                <hr className="my-1"/>
                <li className="nav-item d-flex align-items-center paso4Result">
                  <span className="p-input-icon-left">
                    <i className="pi pi-list" />
                    <InputText
                      className="w-100"
                      type="number"
                      onChange={(e) => setCantPuestos(e.target.value)}
                      placeholder="Cantidad puestos"
                    />
                  </span>
                </li>
                <hr className="my-1"/>
                <li className="nav-item d-flex align-items-center paso5Result">
                  <span className="p-input-icon-left">
                    <i className="pi pi-user" />
                    <InputText
                      className="w-100"
                      type="number"
                      onChange={(e) => setIdentidad(e.target.value)}
                      placeholder="Ti/Cc del deportista"
                    />
                  </span>
                </li>
                <hr className="my-1"/>
                <li className="nav-item d-flex align-items-center paso6Result">
                  <span className="p-input-icon-left w-100">
                    <i className="pi pi-users" />
                    <Dropdown className="w-100 me-2" value={nombreClub} onChange={(e) => setNombreClub(e.value)} options={nombresClubs} optionLabel="name" 
                      placeholder="Elige el equipo" />
                  </span>
                </li>
                <hr className="my-1"/>
                {usuarioFamilia && (
                  <li className="nav-item d-flex align-items-center p-1" style={{cursor: 'pointer'}} onClick={() => cerrarSesionFamilia()}>
                    <i className="pi pi-sign-out me-1 ms-1 text-danger"></i>
                    <span className="text-danger" style={{fontFamily: 'Merriweather Sans'}}>Cerrar Sesión</span>
                  </li>
                )}
                {usuarioFamilia && (
                  <hr className="my-1"/>
                )}
              </ul>
            </>
          )}
        </Sidebar>
        <TabView scrollable activeIndex={activeIndexTab} onTabChange={onTabChange}>
          <TabPanel header={`${clubes.filter((club) => deportistas.filter((depor) => depor.nombreclub === club.nombreclub).length !== 0).length} Equipos`} leftIcon='pi pi-flag me-2'>
            <DataTable value={clubes.filter((club) => deportistas.filter((depor) => depor.nombreclub === club.nombreclub).length !== 0)} size='small' paginator rows={20} rowsPerPageOptions={[30, 40, 50, 60]} stripedRows emptyMessage="No hay clubes inscritos aún."
            expandedRows={expandedRowsContabilidad} onRowToggle={(e) => setExpandedRowsContabilidad(e.data)} rowExpansionTemplate={rowExpansionTemplateContabilidad} tableStyle={{ minWidth: '40rem', margin: 'auto'}}>
              <Column expander style={{ width: '30px' }} />
              <Column header="#" body={(_, index)=>{return index.rowIndex + 1}} style={{ width: '30px'}}></Column>
              <Column header="Directivos" style={{ width: '160px'}} body={(club) => {return sacarDirectivos(club.directivos)}}></Column>
              <Column body={(club) => <Avatar className="d-flex align-items-center justify-content-center shadow" image={club.photo} label={club.photo !== null ? '' : club.nombreclub[0]}/>} style={{ width: '30px'}}></Column>
              <Column field="nombreclub" header="Equipo" style={{ width: '130px'}}></Column>
              <Column header="Deportistas" body={(club) => {return deportistas.filter((depor) => depor.nombreclub === club.nombreclub).length}} style={{ width: '120px'}}></Column>
            </DataTable>
          </TabPanel>
          <TabPanel header="Programa" leftIcon='pi pi-clipboard me-2'>
            {!usuarioFamilia ? (
              <div className="w-100 alert alert-info alert-warning fade show m-auto p-1 mt-3 shadow" role="alert" style={{ maxWidth: '500px' }}>
                <p className="text-center m-0" style={{lineHeight: 1.2}}>Ingresa con una cuenta de Google.</p>
                <hr className="my-1"/>
                <Button icon='pi pi-google' className="w-auto p-1 px-2 rounded-3 mx-1" severity="secondary" label="Acceso" size="small" onClick={() => loginGoogle()}></Button>
              </div>
            ):( 
              <div className="table-responsive-sm">
                {programacion.length !== 0 ?(
                  <div className="d-flex flex-wrap justify-content-start align-items-center border-bottom">
                    {urlProgramacion ?( 
                      <div className="d-flex flex-wrap justify-content-start">
                        <Link to={urlProgramacion} target='_blank' className="text-light">
                          <Button icon='pi pi-file-pdf' severity="danger" className="m-1 py-1 rounded-3"/>
                        </Link>
                      </div>
                    ):(
                      <></>
                    )}
                  </div>
                ):(
                  <></>
                )}
                <div className='d-flex flex-wrap justify-content-center'>
                  {programacion.length !== 0 ? (
                    programacion.filter((programa)=> globalFilter !== '' ? (((programa.id) + '') === globalFilter) : (programa.id + '') !== '').slice(0, visibleCountPrograma).map((prue, indexPrue)=>{
                      return <form key={indexPrue} className='formulario-tablas text-center'>
                      <motion.table
                      className='shadow tabla-tiempos'
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      transition={{duration: 1}}
                      style={{margin: '4px', width: '530px', borderRadius: '20px 0', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}
                      >
                        <thead className='text-light'>
                          <tr style={{borderBottom: '1px solid white'}}>
                            <td style={{fontSize: '16px', fontFamily: 'Fira Sans Extra Condensed'}} colSpan={9}>
                              {resultados.length - 1 === indexPrue ?(
                                <span className='d-flex justify-content-between aling-items-center'>
                                  <div className='ms-1 mb-1'>
                                    <Tag rounded className='me-1 bg-warning border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                    <Tag severity="success" rounded className='me-1 border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                    <Tag severity="danger" rounded className="border border-dark" value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                  </div>
                                  En Curso...
                                </span>
                              ):(
                                <div className='d-flex justify-content-between aling-items-center'>
                                  <div className='ms-1 mb-1'>
                                    <Tag rounded className='me-1 bg-warning border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                    <Tag severity="success" rounded className='me-1 border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                    <Tag severity="danger" rounded className="border border-dark" value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                  </div>
                                  <span className='me-2 pt-1'>
                                    Terminada ✔
                                  </span>
                                </div>
                              )}
                            </td>
                          </tr>
                          <tr style={{borderBottom: '1px solid white'}}>
                            <th className='id fs-4' style={{borderRight: '1px solid white'}}>{prue.id}</th>
                            <th style={{fontSize: '18px'}} colSpan={4}>{`${prue.categoria}`}</th>
                          </tr>
                          <tr className='bg-light text-dark' style={{borderBottom: '1px solid white'}}>
                            <th style={{fontSize: '18px'}} colSpan={5}>{prue.prueba}</th>
                          </tr> 
                          {(recordsEvento.length !== 0 && prue.planilla.length !== 0) && (
                            recordsEvento.filter((rec) => rec.prueba === prue.prueba && rec.genero === prue.planilla[0].nadadores[0].genero).map((rec, indexRec)=>{
                              return <tr key={indexRec} style={{borderBottom: '1px solid white'}}>
                                <th><i className="pi pi-crown text-warning"></i></th>
                                <th style={{fontSize: '14px', maxWidth: '227px'}} colSpan={2}>
                                  <div className="marqueePwsResult">
                                    <div className="marquee__innerPwsResult">
                                      <span>{`POSEEDOR${rec.genero === 'Femenino' ? 'A ' : ' '}DEL RÉCORD ABSOLUTO: ` + rec.deportista.toUpperCase() + ' DE ' + rec.club + ' - '}</span>
                                      <span>{`POSEEDOR${rec.genero === 'Femenino' ? 'A ' : ' '}DEL RÉCORD ABSOLUTO: ` + rec.deportista.toUpperCase() + ' DE ' + rec.club + ' - '}</span>
                                      <span>{`POSEEDOR${rec.genero === 'Femenino' ? 'A ' : ' '}DEL RÉCORD ABSOLUTO: ` + rec.deportista.toUpperCase() + ' DE ' + rec.club + ' - '}</span>
                                    </div>
                                  </div>
                                </th>
                                <th>{arreglarTiempoEstandar(rec.record)}</th>
                              </tr>
                            })
                          )}
                        </thead>
                        {
                          prue.planilla.length !== 0 ?
                          prue.planilla.map((nadador, nadadorIndex)=>{
                            return <tbody key={nadadorIndex}>
                              <tr>
                                <th className='text-light text-start ps-2' colSpan={5}>{`Serie: ${nadador.Serie}`}</th>
                              </tr>
                              {
                                nadador.nadadores.map((user, index)=>{
                                  return user.nombre.length !== 0 ?(
                                    <tr key={index}
                                      style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${index}`}}>
                                      <td className={`${user.identificacion[0] === identidad || user.nombreclub[0] === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', background: 'white' , borderRadius: '20px 0 0 0', borderRight: '1px solid #d8d8d8'}}>{user.carril}</td>
                                      <td className={`${user.identificacion[0] === identidad || user.nombreclub[0] === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', background: 'white', borderRight: '1px solid #d8d8d8'}}>{banderas(user.departamento, user.codePais)}</td>
                                      {user.equipo ?(
                                        <td className={`text-start ${user.identificacion[0] === identidad || user.nombreclub[0] === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', background: `white`, borderRight: '1px solid #d8d8d8'}}>
                                          {user.equipo.map((eq, indexEq)=>{
                                            return <span key={indexEq}>{eq} <hr className='m-0'/></span>
                                          })}
                                          <label className="w-100 text-end fw-bold" style={{fontSize: "11px"}}>{user.nombreclub}</label>
                                        </td>
                                      ):(
                                        <td className={`text-start ${user.identificacion[0] === identidad || user.nombreclub[0] === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', background: `white`, borderRight: '1px solid #d8d8d8'}}>
                                          <label className="d-flex flex-column">
                                            <label style={{cursor: 'pointer'}}>{user.nombre} {user?.verificado === 'Verificado' ? <i title='Verificado' className='pi pi-verified text-primary bg-info rounded-circle'></i> : ''}</label>
                                            <label className="text-end fw-bold" style={{fontSize: "11px"}}>{user.nombreclub}</label>
                                          </label>
                                        </td>
                                      )}
                                      {user.equipo ? (
                                        <td className={`${user.identificacion[0] === identidad || user.nombreclub[0] === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', background: `white`}}>
                                          {user.edades.map((ed, indexEd) =>{
                                            return <span key={indexEd}>{ed} <hr className='m-0'/></span>
                                          })}
                                          <label className="w-100 text-end fw-bold" style={{fontSize: "11px"}}></label>
                                        </td>
                                      ):(
                                        <td className="fw-bold bg-tiempos text-light" style={{fontSize: '14px'}}>{`${user.edad}`}</td>
                                      )}
                                    </tr>
                                  ):(
                                    <></>
                                  )
                                })
                              }
                            </tbody>
                          })
                          :
                          <tbody>
                            <tr>
                              <th className='text-light text-start ps-2' colSpan={5}>Serie: 1</th>
                            </tr>
                            <tr>
                              <td className='bg-light' style={{ borderRadius: '0 0 20px 0' }} colSpan={5}>No hay deportistas aún.</td>
                            </tr>
                          </tbody>
                        }
                      </motion.table>
                      </form>
                    })
                  ):(
                    <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{duration: 1}}
                    className="w-100"
                    >
                      <div className='p-5 text-center'>
                        <img className='m-auto' style={{width: '230px'}} src={require('../img/img-logo-swimmingt.webp')} alt="logo prowebsports" />
                        <h1>¡Bienvenido!</h1>
                        <p>No se ha registrado la programación aún.</p>
                      </div>
                    </motion.div>
                  )}
                </div>
              </div>
            )}
          </TabPanel>
          <TabPanel header="Puestos" leftIcon='pi pi-list-check me-2'>
             {usuarioFamilia && (
              <>
                {resultados.length !== 0 &&(
                  <div className="d-flex flex-wrap justify-content-start align-items-center border-bottom">
                    <ToggleButton type="button" className={`btn m-1 ${seguimiento ? 'btn-success' : 'border'}`} onLabel='Seguimiento' offLabel='Seguimiento' onIcon="pi pi-eye" offIcon="pi pi-eye-slash" onChange={(e) => setSeguimiento(e.value)} checked={seguimiento} style={{width: 'auto'}}/>
                    {urlResultados ?(
                      <div className="d-flex flex-wrap justify-content-start">
                        <Link to={urlResultados} target='_blank' className="text-light">
                          <Button type="button" icon='pi pi-file-pdf' severity="danger" className="m-1 py-1 rounded-3"/>
                        </Link>
                      </div>
                    ):(
                      <></>
                    )}
                  </div>
                )}
                {!isIOS() && (
                  <motion.div className="mt-1"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{duration: 1}}
                  >
                    <Swiper modules={[Autoplay]}
                    autoplay={{ delay: 10000, pauseOnMouseEnter: true, disableOnInteraction: false, }}
                    loop={true}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      720: { slidesPerView: 2 },
                      1060: { slidesPerView: 3 },
                      1520: { slidesPerView: 4 },
                      1900: { slidesPerView: 5 },
                    }}>
                      {resultados.length !== 0 &&(
                        resultados.filter((resu)=> globalFilter !== '' ? (((resu.id + 1) + '') === globalFilter) : (resu.id + '') !== '').map((resul, indexResult)=>{
                          return (resul.nadadores.length > 1) && (
                            <SwiperSlide key={indexResult}>
                              <div className="position-relative m-auto border p-1 overflow-hidden" style={{ width: '350px', borderRadius: '8px 8px 0 0' }}>
                                <span className="position-absolute texto-borde w-100 fw-bold text-start" style={{top: '2px', fontSize: '46px', lineHeight: 1.2}}>{titulosTorneos.find((titulo)=> titulo.idTorneo === evento)?.titulo}</span>
                                <img className="position-absolute start-50 translate-middle" style={{top: '130px', width: '200px', filter: "drop-shadow(-1px 1px 1px black)"}} src={require('../img/img_logo.png')} alt="logo" />
                                <img className="position-absolute top-0 end-0 mt-1 me-1" style={{width: '45px'}} src={require('../img/img-logo-swimmingt.webp')} alt="logo" />
                                {(resul.nadadores.length === 2) && ( 
                                  <div>
                                    {resul.nadadores[0].genero === 'Femenino' ? <img className="w-100" style={{filter: "drop-shadow(-1px 1px 1px black)"}} src={require('../img/podio-damas.png')} alt="imagen de podio prowebsports" /> : <img className="w-100" style={{filter: "drop-shadow(-1px 1px 1px black)"}} src={require('../img/podio-varones.png')} alt="imagen de podio prowebsports" />}
                                    {resul.nadadores[1].posicion !== 9999 && (
                                      <>
                                        <span className="position-absolute text-center text-light p-1" style={{width: '103px', fontSize: '14px', left: (resul.nadadores[0].genero === 'Masculino' || resul.nadadores[0].genero === '') ? '19px' : '15px', bottom: '65px', lineHeight: 1.1, background: 'linear-gradient(340deg, rgba(9, 67, 121, 0.8) 60%, rgba(0, 212, 255, 0.5) 100%)', zIndex: 2, borderRadius: '8px 0 0 0'}}>{resul.nadadores[1].nombre}</span>
                                        <span className="position-absolute text-center" style={{width: '150px', fontSize: '14px', left: 0, top: '35px'}}>{banderas(resul.nadadores[1].departamento, resul.nadadores[1].codePais)}</span>
                                      </>
                                    )}
                                    {resul.nadadores[0].posicion !== 9999 && (
                                      <>
                                        <span className="position-absolute text-center text-light p-1" style={{width: '103px', fontSize: '14px', left: (resul.nadadores[0].genero === 'Masculino' || resul.nadadores[0].genero === '') ? '121px' : '118px', bottom: '116px', lineHeight: 1.1, background: 'linear-gradient(340deg, rgba(9, 67, 121, 0.8) 60%, rgba(0, 212, 255, 0.5) 100%)', zIndex: 2, borderRadius: '8px 8px 0 0'}}>{resul.nadadores[0].nombre}</span>
                                        <span className="position-absolute text-center" style={{width: '150px', fontSize: '14px', left: '95px', top: '5px'}}>{banderas(resul.nadadores[0].departamento, resul.nadadores[0].codePais)}</span>
                                      </>
                                    )}
                                  </div>
                                )}
                                {resul.nadadores.length >= 3 && (
                                  <div>
                                    {resul.nadadores[0].genero === 'Femenino' ? <img className="w-100 position-relative" style={{filter: "drop-shadow(-1px 1px 1px black)", zIndex: 1}} src={require('../img/podio-damas.png')} alt="imagen de podio prowebsports" /> : <img className="w-100 position-relative" style={{filter: "drop-shadow(-1px 1px 1px black)", zIndex: 1}} src={require('../img/podio-varones.png')} alt="imagen de podio prowebsports" />}
                                    {resul.nadadores[1].posicion !== 9999 && (
                                      <>
                                        <span className="position-absolute text-center text-light p-1" style={{width: '103px', fontSize: '14px', left: (resul.nadadores[0].genero === 'Masculino' || resul.nadadores[0].genero === '') ? '19px' : '15px', bottom: '65px', lineHeight: 1.1, background: 'linear-gradient(340deg, rgba(9, 67, 121, 0.8) 60%, rgba(0, 212, 255, 0.5) 100%)', zIndex: 2, borderRadius: '8px 0 0 0'}}>{resul.nadadores[1].nombre}</span>
                                        <span className="position-absolute text-center" style={{width: '150px', fontSize: '14px', left: 0, top: '35px'}}>{banderas(resul.nadadores[1].departamento, resul.nadadores[1].codePais)}</span>
                                      </>
                                    )}
                                    {resul.nadadores[0].posicion !== 9999 && (
                                      <>
                                        <span className="position-absolute text-center text-light p-1" style={{width: '103px', fontSize: '14px', left: (resul.nadadores[0].genero === 'Masculino' || resul.nadadores[0].genero === '') ? '121px' : '118px', bottom: '116px', lineHeight: 1.1, background: 'linear-gradient(340deg, rgba(9, 67, 121, 0.8) 60%, rgba(0, 212, 255, 0.5) 100%)', zIndex: 2, borderRadius: '8px 8px 0 0'}}>{resul.nadadores[0].nombre}</span>
                                        <span className="position-absolute text-center" style={{width: '150px', fontSize: '14px', left: '95px', top: '5px'}}>{banderas(resul.nadadores[0].departamento, resul.nadadores[0].codePais)}</span>
                                      </>
                                    )}
                                    {resul.nadadores[2].posicion !== 9999 && (
                                      <>
                                        <span className="position-absolute text-center text-light p-1" style={{width: '108px', fontSize: '14px', left: (resul.nadadores[0].genero === 'Masculino' || resul.nadadores[0].genero === '') ? '223px' : '221px', bottom: '62px', lineHeight: 1.1, background: 'linear-gradient(340deg, rgba(9, 67, 121, 0.8) 60%, rgba(0, 212, 255, 0.5) 100%)', zIndex: 2, borderRadius: '0 8px 0 0'}}>{resul.nadadores[2].nombre}</span>
                                        <span className="position-absolute text-center" style={{width: '150px', fontSize: '14px', left: '205px', top: '45px'}}>{banderas(resul.nadadores[2].departamento, resul.nadadores[2].codePais)}</span>
                                      </>
                                    )}
                                  </div>
                                )}
                                <span className="text-center text-light bg-dark d-block" style={{fontSize: '14px', borderRadius: '15px 20px 0 0'}}>{'Prueba #' + (resul.id + 1) + ' - ' + resul.prueba.prueba}</span>
                              </div>
                            </SwiperSlide>
                          )
                        })
                      )}
                    </Swiper>
                  </motion.div>
                )}
              </>
            )}
            <hr className="my-1"/>
            <div className="d-flex flex-wrap justify-content-center text-center">
              {resultados.length !== 0 ?(
                resultados.filter((resu)=> globalFilter !== '' ? (((resu.id + 1) + '') === globalFilter) : (resu.id + '') !== '').slice(0, visibleCount).map((result, indexResult)=>{
                  return <form key={indexResult} className='formulario-tablas table-responsive-sm'>
                    <motion.table style={{margin: '4px', width: '530px', borderRadius: '20px 0', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{duration: 1}}
                    className='shadow tabla-tiempos'
                    >
                      <thead className='text-light'>
                        <tr style={{borderBottom: '1px solid white'}}>
                          <td style={{fontSize: '16px', fontFamily: 'Fira Sans Extra Condensed'}} colSpan={9}>
                            {resultados.length - 1 === indexResult || seguimiento ?(
                              <span className='d-flex justify-content-between aling-items-center'>
                                <div className='ms-1 mb-1'>
                                  <Tag id={`#01ranking${indexResult}`} rounded className='me-1 bg-warning border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                  <Tag id={`rankingN${indexResult}`} severity="success" rounded className='me-1 border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                  <Tag id={`rankingD${indexResult}`} severity="danger" rounded className="border border-dark" value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                </div>
                                {result.nadadores.length === 1 && puntuar === 'no' ? 'No Acumula Para El Trofeo - ' : ''} En Curso...
                              </span>
                            ):(
                              <div className='d-flex justify-content-between aling-items-center'>
                                <div className='ms-1 mb-1'>
                                  <Tag id={`#01ranking${indexResult}`} rounded className='me-1 bg-warning border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                  <Tag id={`rankingN${indexResult}`} severity="success" rounded className='me-1 border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                  <Tag id={`rankingD${indexResult}`} severity="danger" rounded className="border border-dark" value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                </div>
                                <span className='me-2 pt-1'>
                                  {result.nadadores.length === 1 && puntuar === 'no' ? 'No Acumula Para El Trofeo - ' : ''} Terminada ✔
                                </span>
                              </div>
                            )}
                          </td>
                        </tr>
                        <tr style={{borderBottom: '1px solid white'}}>
                          <th className='id fs-4'>{result.id + 1}</th>
                          <th style={{fontSize: '18px', borderLeft: '1px solid white'}} colSpan={6}>{result.categoria}</th>
                        </tr>
                        <tr style={{borderBottom: '1px solid white'}}> 
                          <th style={{fontSize: '18px'}} colSpan={7}>{result.prueba.prueba}</th>
                        </tr>
                        {(recordsEvento.length !== 0 && result.nadadores.length !== 0) && (
                          recordsEvento.filter((rec) => rec.prueba === result.prueba.prueba && rec.genero === result.nadadores[0].genero).map((rec, indexRec)=>{
                            return <tr key={indexRec} style={{borderBottom: '1px solid white'}}>
                              <th><i className="pi pi-crown text-warning"></i></th>
                              <th style={{fontSize: '14px', maxWidth: '227px'}} colSpan={4}>
                                <div className="marqueePwsResult">
                                  <div className="marquee__innerPwsResult">
                                    <span>{`POSEEDOR${rec.genero === 'Femenino' ? 'A ' : ' '}DEL RÉCORD ABSOLUTO: ` + rec.deportista.toUpperCase() + ' DE ' + rec.club + ' - '}</span>
                                    <span>{`POSEEDOR${rec.genero === 'Femenino' ? 'A ' : ' '}DEL RÉCORD ABSOLUTO: ` + rec.deportista.toUpperCase() + ' DE ' + rec.club + ' - '}</span>
                                    <span>{`POSEEDOR${rec.genero === 'Femenino' ? 'A ' : ' '}DEL RÉCORD ABSOLUTO: ` + rec.deportista.toUpperCase() + ' DE ' + rec.club + ' - '}</span>
                                  </div>
                                </div>
                              </th>
                              <th colSpan={2}>{arreglarTiempoEstandar(rec.record)}</th>
                            </tr>
                          })
                        )}
                        {seguimiento ? (
                          <tr style={{borderBottom: '1px solid gray'}}>
                            <th colSpan={6}>
                              <div className="d-flex justify-content-around">
                                <Chip template={
                                <>
                                  <span className="p-chip-icon pi pi-trophy"></span>
                                  <span className="fw-bold" style={{fontSize: '12px'}}>{trofeoClubes[0]?.club}</span>
                                  <span className="pi pi-star-fill ps-1"></span>
                                </>}/>
                                <Chip template={
                                <>
                                  <span className="p-chip-icon pi pi-trophy"></span>
                                  <span className="fw-bold" style={{fontSize: '12px'}}>{trofeoPuntosClubes[0]?.club}</span>
                                  <span className="pi pi-spinner-dotted ps-1"></span>
                                </>}/>
                              </div>
                            </th>
                          </tr>
                        ):(
                          <></>
                        )}
                        <tr>
                          <th style={{fontSize: '15px', borderRight: '1px solid white'}}>Psto</th>
                          <th style={{width: '50px', fontSize: '15px', borderRight: '1px solid white'}}>Ln-Sr</th>
                          <th colSpan={2} style={{fontSize: '15px', borderRight: '1px solid white'}}>Deportista</th>
                          <th style={{fontSize: '15px', borderRight: '1px solid white'}}>Tiempo</th>
                          <th style={{fontSize: '15px', borderRight: '1px solid white'}}>W.A</th>
                          <th style={{fontSize: '15px'}}><img style={{width: '30px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" /></th>
                        </tr>
                      </thead>
                      <tbody>
                        {result.nadadores.slice(0, cantPuestos === '' ? result.nadadores.length : cantPuestos).map((nadador, indexNadador)=>{
                          return <motion.tr key={indexNadador}
                          initial={{ x: -1000, opacity: 0}}
                          animate={{ x: animateList ? -1000 : 0.1, opacity: animateList ? 0 : 1}}
                          transition={{ duration: 0.5, delay: `0.${indexNadador}`, type: 'spring'}}
                          style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexNadador}`}}
                          >
                            {nadador.posicion === 1 ? <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" /></td> : nadador.posicion === 2 ? <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-2.png")} alt="medalla segundo lugar" /></td> :  nadador.posicion === 3 ? <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-3.png")} alt="medalla tercer lugar" /></td> : <td className={`pt-2 pb-2 ${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}>{nadador.posicion !== 9999 ? nadador.posicion : '-'}</td>}
                            <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{nadador.carril + '-' + nadador.serie}</td>
                            <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{banderas(nadador.departamento, nadador.codePais)}</td>
                            {nadador.equipo !== null ?(
                              <td className={`text-start ${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>
                                {nadador.equipo.map((eq, indexEq)=>{
                                  return <span key={indexEq}>{eq} <hr className='m-0'/></span>
                                })}
                                <label className="w-100 text-end fw-bold" style={{fontSize: "11px"}}>{nadador.nombreclub}</label>
                              </td>
                              ):(
                                <td className={`text-start ${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}} onClick={() => sacarHistorialDeportista(nadador)}><label className="d-flex flex-column">
                                  <label style={{cursor: 'pointer'}}>{nadador.nombre} {nadador?.verificado === 'Verificado' ? <i title='Verificado' className='pi pi-verified text-primary bg-info rounded-circle'></i> : ''}</label>
                                  <label className="text-end fw-bold" style={{fontSize: "11px"}}>{nadador.nombreclub}</label>
                                </label></td>
                            )}
                            <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-tiempos text-light' : (nadador.tiempo === '0:0:0' || nadador.tiempo === '61:0:0') ? 'bg-danger text-light' : 'bg-tiempos text-light'}`} style={{fontSize: '15px', fontFamily: 'Poppins'}}>{nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : <label className="w-100 fw-bold d-flex flex-column text-end"><li style={{fontSize: '13px', textShadow: '0 0 8px black'}} className={manejoRendimiento(nadador.record, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo) >= 0 ? 'pi pi-arrow-down text-success text-start' : 'pi pi-arrow-up text-danger text-start'}>{arreglarFormatoTiempo(manejoRendimiento(nadador.record, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo))}</li>{arreglarTiempoEstandar(nadador.tiempo)}</label>}</td>
                            <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light fw-bold' : 'fw-bold'}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{calcularPuntosWorldAquatics(nadador.tiempo, nadador.genero, result.prueba.prueba, piscina)}</td>
                            <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-tiempos text-light fw-bold' : (nadador.tiempo === '0:0:0' || nadador.tiempo === '61:0:0') ? 'bg-danger text-light fw-bold' : 'bg-tiempos text-light fw-bold'}`} style={{fontSize: '14px', fontFamily: 'Poppins', borderRadius: '0 0 20px 0'}}>{arreglarFormatoTiempo(manejoRendimiento(result.nadadores[0].tiempo, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo))}</td>
                          </motion.tr>
                        })}
                      </tbody>
                    </motion.table>
                  </form> 
                })
              ):(
                <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{duration: 1}}
                className="w-100"
                >
                  <div className='p-5 text-center'>
                    <img className='m-auto' style={{width: '230px'}} src={require('../img/img-logo-swimmingt.webp')} alt="logo prowebsports" />
                    <h1>¡Bienvenido!</h1>
                    <p>No tenemos registros de tiempos aún.</p>
                  </div>
                </motion.div>
              )}
            </div>
          </TabPanel>
          <TabPanel header="Series" leftIcon='pi pi-arrow-right-arrow-left me-2'>
            {!eventoPagado ? (
              <div className="w-100 alert alert-info alert-warning fade show m-auto p-1 mt-3 shadow" role="alert" style={{ maxWidth: '500px' }}>
                <p className="text-center m-0" style={{lineHeight: 1.2}}>{!usuarioFamilia && 'Ingresa con tu cuenta de Google y p'}{usuarioFamilia && 'P'}or solo COP <b>{valorCOP}</b> accede a resultados y detalles exclusivos del evento. {!evento && <b><br />Elige un evento</b>}</p>
                <hr className="my-1"/>
                {!usuarioFamilia && <Button icon='pi pi-google' className="w-auto p-1 px-2 rounded-3 mx-1" severity="secondary" label="Acceso" size="small" onClick={() => loginGoogle()}></Button>}
                {(evento && usuarioFamilia) && <Button icon='pi pi-wallet' className="w-auto p-1 px-2 rounded-3 mx-1" severity="secondary" label="Wompi" size="small" onClick={() => pagar()}></Button>}
              </div>
            ):(
              <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}>
                {resultados.length !== 0 && seriesSeparadas.length !== 0 ?(
                  resultados.filter((resu)=> globalFilter !== '' ? (((resu.id + 1) + '') === globalFilter) : (resu.id + '') !== '').slice(0, visibleCount).map((result, indexResult)=>{
                    return <form key={indexResult} className='formulario-tablas table-responsive-sm'>
                    <motion.table style={{margin: '4px', width: '530px', borderRadius: '20px 0', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{duration: 1}}
                    className='shadow tabla-tiempos text-center'
                    >
                      <thead className='text-light'>
                        <tr style={{borderBottom: '1px solid white'}}>
                          <td style={{fontSize: '16px', fontFamily: 'Fira Sans Extra Condensed'}} colSpan={9}>
                            {resultados.length - 1 === indexResult ?(
                              <span className='d-flex justify-content-between aling-items-center'>
                                <div className='ms-1 mb-1'>
                                  <Tag id={`#01ranking${indexResult}`} rounded className='me-1 bg-warning border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                  <Tag id={`rankingN${indexResult}`} severity="success" rounded className='me-1 border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                  <Tag id={`rankingD${indexResult}`} severity="danger" rounded className="" value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                </div>
                                {result.nadadores.length === 1 && puntuar === 'no' ? 'No Acumula Para El Trofeo - ' : ''} En Curso...
                              </span>
                            ):(
                              <div className='d-flex justify-content-between aling-items-center'>
                                <div className='ms-1 mb-1'>
                                  <Tag id={`#01ranking${indexResult}`} rounded className='me-1 bg-warning border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                  <Tag id={`rankingN${indexResult}`} severity="success" rounded className='me-1 border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                  <Tag id={`rankingD${indexResult}`} severity="danger" rounded className="border border-dark" value='' style={{width: '1rem', height: '1rem'}}></Tag>
                                </div>
                                <span className='me-2 pt-1'>
                                  {result.nadadores.length === 1 && puntuar === 'no' ? 'No Acumula Para El Trofeo - ' : ''} Terminada ✔
                                </span>
                              </div>
                            )}
                          </td>
                        </tr>
                        <tr style={{borderBottom: '1px solid white'}}>
                          <th className='id fs-4'>{result.id + 1}</th>
                          <th style={{fontSize: '18px', borderLeft: '1px solid white'}} colSpan={6}>{result.categoria}</th>
                        </tr>
                        <tr style={{borderBottom: '1px solid white'}}>
                          <th style={{fontSize: '18px'}} colSpan={7}>{result.prueba.prueba}</th>
                        </tr>
                        {(recordsEvento.length !== 0 && result.nadadores.length !== 0) && (
                          recordsEvento.filter((rec) => rec.prueba === result.prueba.prueba && rec.genero === result.nadadores[0].genero).map((rec, indexRec)=>{
                            return <tr key={indexRec} style={{borderBottom: '1px solid white'}}>
                              <th><i className="pi pi-crown text-warning"></i></th>
                              <th style={{fontSize: '14px', maxWidth: '227px'}} colSpan={4}>
                                <div className="marqueePwsResult">
                                  <div className="marquee__innerPwsResult">
                                    <span>{`POSEEDOR${rec.genero === 'Femenino' ? 'A ' : ' '}DEL RÉCORD ABSOLUTO: ` + rec.deportista.toUpperCase() + ' DE ' + rec.club + ' - '}</span>
                                    <span>{`POSEEDOR${rec.genero === 'Femenino' ? 'A ' : ' '}DEL RÉCORD ABSOLUTO: ` + rec.deportista.toUpperCase() + ' DE ' + rec.club + ' - '}</span>
                                    <span>{`POSEEDOR${rec.genero === 'Femenino' ? 'A ' : ' '}DEL RÉCORD ABSOLUTO: ` + rec.deportista.toUpperCase() + ' DE ' + rec.club + ' - '}</span>
                                  </div>
                                </div>
                              </th>
                              <th colSpan={2}>{arreglarTiempoEstandar(rec.record)}</th>
                            </tr>
                          })
                        )}
                        <tr>
                          <th style={{fontSize: '15px', borderRight: '1px solid white'}}>Psto</th>
                          <th style={{width: '50px', fontSize: '15px', borderRight: '1px solid white'}}>Ln-Sr</th>
                          <th colSpan={2} style={{fontSize: '15px', borderRight: '1px solid white'}}>Deportista</th>
                          <th style={{fontSize: '15px', borderRight: '1px solid white'}}>Tiempo</th>
                          <th style={{fontSize: '15px', borderRight: '1px solid white'}}>W.A</th>
                          <th style={{fontSize: '15px'}}><img style={{width: '30px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" /></th>
                        </tr>
                      </thead>
                      {(seriesSeparadas[indexResult] && seriesSeparadas[indexResult].series.length !== 0) ?(
                        seriesSeparadas[indexResult].series.map((serie, indexSerie)=>{
                          return <tbody key={indexSerie}>
                            <tr className='bg-tiempos' style={{borderBottom: '1px solid white', borderTop: '1px solid white'}}>
                              <th colSpan={7} className='text-light text-start' style={{fontSize: '16px', borderRight: '1px solid wtiempos'}}>Serie #{indexSerie + 1}</th>
                            </tr>
                            {serie.slice(0, cantPuestos === '' ? serie.length : cantPuestos).map((nadador, indexNadador)=>{
                              return <motion.tr key={indexNadador}
                              initial={{ x: -1000, opacity: 0}}
                              animate={{ x: animateList ? -1000 : 0.1, opacity: animateList ? 0 : 1}}
                              transition={{ duration: 0.5, delay: `0.${indexNadador}`, type: 'spring'}}
                              style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexNadador}`}}
                              >
                                {nadador.posicion === 1 ? <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" /></td> : nadador.posicion === 2 ? <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-2.png")} alt="medalla segundo lugar" /></td> :  nadador.posicion === 3 ? <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-3.png")} alt="medalla tercer lugar" /></td> : <td className={`pt-2 pb-2 ${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}>{nadador.posicion !== 9999 ? nadador.posicion : '-'}</td>}
                                <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{nadador.carril + '-' + nadador.serie}</td>
                                <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{banderas(nadador.departamento, nadador.codePais)}</td>
                                {nadador.equipo !== null ?(
                                  <td className={`text-start ${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>
                                    {nadador.equipo.map((eq, indexEq)=>{
                                      return <span key={indexEq}>{eq} <hr className='m-0'/></span>
                                    })}
                                    <label className="w-100 text-end fw-bold" style={{fontSize: "11px"}}>{nadador.nombreclub}</label>
                                  </td>
                                  ):(
                                    <td className={`text-start ${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}} onClick={() => sacarHistorialDeportista(nadador)}><label className="d-flex flex-column">
                                      <label style={{cursor: 'pointer'}}>{nadador.nombre} {nadador?.verificado === 'Verificado' ? <i title='Verificado' className='pi pi-verified text-primary bg-info rounded-circle'></i> : ''}</label>
                                      <label className="text-end fw-bold" style={{fontSize: "11px"}}>{nadador.nombreclub}</label>
                                    </label></td>
                                )}
                                <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-tiempos text-light' : (nadador.tiempo === '0:0:0' || nadador.tiempo === '61:0:0') ? 'bg-danger text-light' : 'bg-tiempos text-light'}`} style={{fontSize: '15px', fontFamily: 'Poppins'}}>{nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : <label className="w-100 fw-bold d-flex flex-column text-end"><li style={{fontSize: '13px', textShadow: '0 0 8px black'}} className={manejoRendimiento(nadador.record, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo) >= 0 ? 'pi pi-arrow-down text-success text-start' : 'pi pi-arrow-up text-danger text-start'}>{arreglarFormatoTiempo(manejoRendimiento(nadador.record, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo))}</li>{arreglarTiempoEstandar(nadador.tiempo)}</label>}</td>
                                <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-info text-light fw-bold' : 'fw-bold'}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{calcularPuntosWorldAquatics(nadador.tiempo, nadador.genero, result.prueba.prueba, piscina)}</td>
                                <td className={`${nadador.identificacion === identidad || nadador.nombreclub === nombreClub.name ? 'bg-tiempos text-light fw-bold' : (nadador.tiempo === '0:0:0' || nadador.tiempo === '61:0:0') ? 'bg-danger text-light fw-bold' : 'bg-tiempos text-light fw-bold'}`} style={{fontSize: '14px', fontFamily: 'Poppins', borderRadius: '0 0 20px 0'}}>{arreglarFormatoTiempo(manejoRendimiento(result.nadadores[0].tiempo, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo))}</td>
                              </motion.tr>
                            })}
                          </tbody>
                        })
                      ):(
                        <></>
                      )}
                    </motion.table>
                  </form> 
                  }) 
                ):(
                  <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{duration: 1}}
                  style={{borderRadius: '10px'}}
                  >
                    <div className='p-5 text-center'>
                      <img className='m-auto' style={{width: '230px'}} src={require('../img/img-logo-swimmingt.webp')} alt="logo prowebsports" />
                      <h1>¡Bienvenido!</h1>
                      <p>No tenemos registros de tiempos aún.</p>
                    </div>
                  </motion.div>
                )}
              </div>
            )}
          </TabPanel>
          <TabPanel header="Top Deportistas" leftIcon='pi pi-crown me-2'>
            {!eventoPagado ? (
              <div className="w-100 alert alert-info alert-warning fade show m-auto p-1 mt-3 shadow" role="alert" style={{ maxWidth: '500px' }}>
                <p className="text-center m-0" style={{lineHeight: 1.2}}>{!usuarioFamilia && 'Ingresa con tu cuenta de Google y p'}{usuarioFamilia && 'P'}or solo COP <b>{valorCOP}</b> accede a resultados y detalles exclusivos del evento. {!evento && <b><br />Elige un evento</b>}</p>
                <hr className="my-1"/>
                {!usuarioFamilia && <Button icon='pi pi-google' className="w-auto p-1 px-2 rounded-3 mx-1" severity="secondary" label="Acceso" size="small" onClick={() => loginGoogle()}></Button>}
                {(evento && usuarioFamilia) && <Button icon='pi pi-wallet' className="w-auto p-1 px-2 rounded-3 mx-1" severity="secondary" label="Wompi" size="small" onClick={() => pagar()}></Button>}
              </div>
            ):(
              <>
                <div className="alert alert-info alert-dismissible fade show text-start mb-0" role="alert">
                  <h4>El Deportista Más Completo</h4>
                  <p className="mb-0">Suma puntos por posición según World Aquatics, más puntos por rendimiento técnico y bonificación por primer lugar. Pierde puntos si no se presenta (NSP) o es descalificado (DSC).</p>
                  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div className='w-100 m-auto flex-fill row row-cols-1 row-cols-sm-2 row-cols-md-4 justify-content-center align-items-start'>
                  {deportistasMasCompletos.length !== 0 ? (
                    deportistasMasCompletos.map((depor, indexDepor)=>{
                      return depor.nadadores.length !== 0 ?(
                        <motion.div
                          className={`position-relative card m-2 pt-2 col shadow card-torneo card-crear-torneo`}
                          style={{ width: "22rem", background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)' }}
                          key={indexDepor} 
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          transition={{ duration: 1, delay: `0.${indexDepor}5` }}
                          id={`card-torneo${indexDepor}`}
                        >
                          <div className="w-100">
                            <div className='d-flex'>
                              <div>
                                {banderas(depor.nadadores[0]?.departamento, depor.nadadores[0]?.codePais)}
                              </div>
                              <p className='m-0 ms-2' style={{color: 'rgba(212, 212, 212, 1)'}}>{depor.nadadores[0]?.departamento}</p>
                            </div>
                            <div className='bg-light rounded-3 px-1 shadow position-relative'>
                              <img className='position-absolute' src={depor.nadadores[0]?.urlPhoto && depor.nadadores[0]?.urlPhoto !== '' ? depor.nadadores[0].urlPhoto : depor.nadadores[0].genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp')} alt="foto deportista" style={{width: '70px', filter: 'drop-shadow(0 0 2px black) drop-shadow(0 0 1px white)', bottom: '0', right: '0'}}/>
                              <h4 className='card-title mt-1 mb-0 text-start'>{depor.nadadores[0]?.nombre}</h4>
                              <p className='m-0 text-start'>{depor.nadadores[0]?.edad + ' Años'}</p>
                            </div>
                            <p className='m-0 text-start' style={{color: 'rgba(212, 212, 212, 1)'}}>{depor.nadadores[0]?.nombreclub}</p>
                            <hr className='m-0 text-light'/>
                            <h5 className='card-subtitle my-1 text-light text-center'>{depor.nadadores[0]?.grupo + ' - ' + depor.nadadores[0]?.categoria}</h5>
                            <hr className='m-0 text-light'/>
                            {depor.nadadores[0]?.pruebas.length !== 0 ?(
                              depor.nadadores[0]?.pruebas.map((prue, indexPrue)=>{
                                return <div key={indexPrue}>
                                  <div className='d-flex justify-content-center align-items-center' data-bs-toggle="collapse" href={`#collapseExample${indexPrue}${Math.round(prue.id)}`} role='button' aria-expanded="false" aria-controls={`collapseExample${indexPrue}${Math.round(prue.id)}`}>
                                    <div className="text-center">
                                      <p className='m-0' style={{color: 'rgba(212, 212, 212, 1)'}}>{'Prueba #' + (prue.id + 1) + ' - ' + prue.prueba}</p>
                                      <p className='m-0 text-light'>{'Puesto #' + prue.posicion + ' - ' + prue.tiempo}</p>
                                    </div>
                                    <i className='pi pi-angle-down text-light'></i>
                                  </div>
                                  <hr className='m-0 text-light'/>
                                  <div className='collapse' id={`collapseExample${indexPrue}${Math.round(prue.id)}`}>
                                    <div className='d-flex justify-content-between'>
                                      <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>World Aquatics:</p>
                                      <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{(prue.puntosPosicion > 0  ? '+' : '') + prue.puntosPosicion}</p>
                                    </div>
                                    <hr className='m-0 text-light'/>
                                    <div className='d-flex justify-content-between'>
                                      <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Primer Puesto:</p>
                                      <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{(prue.puntosPrimerLugar > 0  ? '+' : '') + prue.puntosPrimerLugar}</p>
                                    </div>
                                    <hr className='m-0 text-light'/>
                                    <div className='d-flex justify-content-between'>
                                      <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Rendimiento Técnico:</p>
                                      <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{(prue.puntosWA > 0  ? '+' : '') + prue.puntosWA}</p>
                                    </div>
                                    <hr className='m-0 text-light'/>
                                    <div className='d-flex justify-content-between'>
                                      <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>NSP:</p>
                                      <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{(prue.puntosNSP > 0  ? '+' : '') + prue.puntosNSP}</p>
                                    </div>
                                    <hr className='m-0 text-light'/>
                                    <div className='d-flex justify-content-between'>
                                      <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>DSC:</p>
                                      <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{(prue.puntosDSC > 0  ? '+' : '') + prue.puntosDSC}</p>
                                    </div>
                                  </div>
                                  <hr className='m-0'/>
                                  <div className='d-flex justify-content-between bg-light shadow px-1'>
                                    <p className='m-0 text-end fw-bold'>Puntos:</p>
                                    <p className='m-0 text-end fw-bold'>{(prue.puntos > 0  ? '+' : '') + prue.puntos.toFixed(2)}</p>
                                  </div>
                                  <hr className='m-0'/>
                                </div>
                              })
                            ):(
                              <></>
                            )}
                            <hr className='m-0'/>
                            <div className='d-flex justify-content-between bg-light shadow mb-2 px-1'>
                              <h5 className='text-end fw-bold m-0'>Total Puntos:</h5>
                              <h5 className='text-end fw-bold m-0'>{depor.nadadores[0]?.puntos.toFixed(2)}</h5>
                            </div>
                          </div>
                        </motion.div>
                      ):(
                        <></>
                      )
                    })
                  ):(
                    <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{duration: 1}}
                    className="w-100"
                    >
                      <div className='p-5 text-center'>
                        <img className='m-auto' style={{width: '230px'}} src={require('../img/img-logo-swimmingt.webp')} alt="logo prowebsports" />
                        <h1>¡Bienvenido!</h1>
                        <p>No tenemos top aún.</p>
                      </div>
                    </motion.div>
                  )}
                </div>
              </>
            )}
          </TabPanel>
          <TabPanel header="Trofeo" leftIcon='pi pi-trophy me-2'>
            <TabView scrollable>
              <TabPanel header="Medallas" leftIcon='pi pi-star-fill me-2'>
                <Accordion className='m-auto pt-1' style={{maxWidth: '850px'}}>
                  <AccordionTab header="Categorias">
                    <div className="d-flex flex-wrap justify-content-evenly">
                      {categoriasDisponibles.map((cate, indexCate)=>{
                        return <div key={indexCate} className="d-flex align-items-center" style={{width: '200px'}}>
                        <Checkbox inputId={cate} name="pizza" value={cate} onChange={sacarCategoriasElegidas} checked={categoriasElegidas.includes(cate)}/>
                        <label htmlFor={cate} className="ml-2">{cate}</label>
                      </div>
                      })}
                    </div>
                  </AccordionTab>
                </Accordion>
                <div className="table-responsive-sm">
                  <table className="shadow w-100" style={{background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}>
                    <thead className='text-light'>
                      <tr>
                        <th className="text-center" style={{padding: '8px', borderRight: '1px solid white'}}>Puesto</th>
                        <th colSpan={2} className="text-center" style={{borderRight: '1px solid white'}}>Equipos</th>
                        <th className="text-center" style={{borderRight: '1px solid white'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" /></th>
                        <th className="text-center" style={{borderRight: '1px solid white'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-2.png")} alt="medalla segundo lugar" /></th>
                        <th className="text-center" style={{borderRight: '1px solid white'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-3.png")} alt="medalla tercer lugar" /></th>
                        <th className="text-center">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {trofeoClubes.length !== 0 ?(
                        trofeoClubes.map((club, indexClub)=>{
                          return <motion.tr key={indexClub}
                          className="text-center"
                          initial={{ scale: 0}}
                          animate={{ scale: animateList ? 0 : 1}}
                          transition={{ duration: 0.5, delay: `0.${indexClub}`, type: 'spring'}}
                          style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexClub}`}}
                          >
                            {indexClub === 0 ? <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}><img style={{width: '50px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-trofeo-1.png")} alt="trofeo primer lugar" /></td> : indexClub === 1 ? <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}><img style={{width: '50px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-trofeo-2.png")} alt="trofeo segundo lugar" /></td> :  indexClub === 2 ? <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}><img style={{width: '50px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-trofeo-3.png")} alt="trofeo tercer lugar" /></td> : <td className={`pt-2 pb-2 ${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}>{indexClub + 1}</td>}
                            <td className={`text-start ${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white', cursor: 'pointer'}} onClick={() => sacarHistorialEquipo(club)}>
                              {club.club}
                              <span className="border rounded-5 d-flex m-end" style={{width: '100%', height: '12px'}}>
                                <span className="d-block text-center text-light" style={{fontSize: '10px', lineHeight: 1, width: `${Math.round((club.oro / trofeoClubes.reduce((acumulador, objeto)=> {return acumulador + objeto.oro}, 0)) * 100)}%`, height: '10px', background: '#D4AF37', borderRadius: '8px 0 0 8px', textShadow: '0 0 2px black'}}>
                                  {Math.round((club.oro / trofeoClubes.reduce((acumulador, objeto)=> {return acumulador + objeto.oro}, 0)) * 100)}%
                                </span>
                                <span className="d-block text-center text-light" style={{fontSize: '10px', lineHeight: 1, width: `${Math.round((club.plata / trofeoClubes.reduce((acumulador, objeto)=> {return acumulador + objeto.plata}, 0)) * 100)}%`, height: '10px', background: '#C0C0C0', textShadow: '0 0 2px black'}}>
                                  {Math.round((club.plata / trofeoClubes.reduce((acumulador, objeto)=> {return acumulador + objeto.plata}, 0)) * 100)}%
                                </span>
                                <span className="d-block text-center text-light" style={{fontSize: '10px', lineHeight: 1, width: `${Math.round((club.bronce / trofeoClubes.reduce((acumulador, objeto)=> {return acumulador + objeto.bronce}, 0)) * 100)}%`, height: '10px', background: '#CD7F32', borderRadius: '0 8px 8px 0', textShadow: '0 0 2px black'}}>
                                  {Math.round((club.bronce / trofeoClubes.reduce((acumulador, objeto)=> {return acumulador + objeto.bronce}, 0)) * 100)}%
                                </span>
                              </span>
                            </td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{banderas(club.departamento, club.codePais)}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.oro}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.plata}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.bronce}</td>
                            <th className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white', borderRadius: '0 0 20px 0'}}>{club.total}</th>
                          </motion.tr>
                        })
                      ):(
                        <tr>
                          <td colSpan={8} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>El torneo aún no empieza.</td>
                        </tr>
                      )
                      }
                    </tbody>
                  </table>
                </div>
              </TabPanel>
              <TabPanel header="Puntos" leftIcon='pi pi-spinner-dotted me-2'>
                <Accordion className='m-auto pt-1' style={{maxWidth: '850px'}}>
                  <AccordionTab header="Categorias">
                    <div className="d-flex flex-wrap justify-content-evenly">
                      {categoriasDisponibles.map((cate, indexCate)=>{
                        return <div key={indexCate} className="d-flex align-items-center" style={{width: '200px'}}>
                        <Checkbox inputId={cate} name="pizza" value={cate} onChange={sacarCategoriasPuntosClubElegidas} checked={categoriasPuntosClubElegidas.includes(cate)}/>
                        <label htmlFor={cate} className="ml-2">{cate}</label>
                      </div>
                      })}
                    </div>
                  </AccordionTab>
                </Accordion>
                <div className="table-responsive-sm">
                  <table className='w-100' style={{background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}>
                    <thead className='text-light'>
                      {numeroCarriles !== 10 ?(
                        <tr className="text-center">
                          <th className="clubes" style={{padding: '8px', borderRight: '1px solid white'}}>Puesto</th>
                          <th colSpan={2} className="clubes">Equipos</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>1</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>2</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>3</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>4</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>5</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>6</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>7</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>8</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>9</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>10</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>11</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>12</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>13</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>14</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>15</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>16</th>
                          <th className="total">Total</th>
                        </tr>
                      ):(
                        <tr className="text-center">
                          <th className="clubes" style={{padding: '8px', borderRight: '1px solid gray'}}>Puesto</th>
                          <th colSpan={2} className="clubes">Equipos</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>1</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>2</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>3</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>4</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>5</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>6</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>7</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>8</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>9</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>10</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>11</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>12</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>13</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>14</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>15</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>16</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>17</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>18</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>19</th>
                          <th className="clubes" style={{borderRight: '1px solid white'}}>20</th>
                          <th className="total">Total</th>
                        </tr>
                      )}
                    </thead>
                    <tbody>
                      {trofeoPuntosClubes.length !== 0 ?(
                        trofeoPuntosClubes.map((club, indexClub)=>{
                          return <motion.tr key={indexClub}
                          className="text-center"
                          initial={{ scale: 0}}
                          animate={{ scale: animateList ? 0 : 1}}
                          transition={{ duration: 0.5, delay: `0.${indexClub}`, type: 'spring'}}
                          style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexClub}`}}
                          >
                            {indexClub === 0 ? <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}><img style={{width: '50px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-trofeo-1.png")} alt="trofeo primer lugar" /></td> : indexClub === 1 ? <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}><img style={{width: '50px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-trofeo-2.png")} alt="trofeo segundo lugar" /></td> :  indexClub === 2 ? <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}><img style={{width: '50px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-trofeo-3.png")} alt="trofeo tercer lugar" /></td> : <td className={`pt-2 pb-2 ${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}>{indexClub + 1}</td>}
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white', cursor: 'pointer'}} onClick={() => sacarHistorialEquipo(club)}>{club.club}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{banderas(club.departamento, club.codePais)}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto1}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto2}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto3}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto4}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto5}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto6}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto7}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto8}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto9}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto10}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto11}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto12}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto13}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto14}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto15}</td>
                            <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto16}</td>
                            {numeroCarriles === 10 ?(
                              <>
                                <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto17}</td>
                                <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto18}</td>
                                <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto19}</td>
                                <td className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.punto20}</td>
                              </>
                            ):(
                              <></>
                            )}
                            <th className={`${club.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white', borderRadius: '0 0 20px 0'}}>{club.total}</th>
                          </motion.tr>
                        })
                      ):(
                        <tr>
                          <td colSpan={21} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>El torneo aún no empieza.</td>
                        </tr>
                      )
                      }
                    </tbody>
                  </table>
                </div>
              </TabPanel>
              <TabPanel header="Región" leftIcon='pi pi-tag me-2'>
                <Accordion className='m-auto pt-1' style={{maxWidth: '850px'}}>
                  <AccordionTab header="Categorias">
                    <div className="d-flex flex-wrap justify-content-evenly">
                      {categoriasDisponibles.map((cate, indexCate)=>{
                        return <div key={indexCate} className="d-flex align-items-center" style={{width: '200px'}}>
                        <Checkbox inputId={cate} name="pizza" value={cate} onChange={sacarCategoriasElegidas} checked={categoriasElegidas.includes(cate)}/>
                        <label htmlFor={cate} className="ml-2">{cate}</label>
                      </div>
                      })}
                    </div>
                  </AccordionTab>
                </Accordion>
                <div className="table-responsive-sm">
                  <table className="shadow w-100" style={{background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}>
                    <thead className='text-light'>
                      <tr>
                        <th className="text-center" style={{padding: '8px', borderRight: '1px solid white'}}>Puesto</th>
                        <th colSpan={2} className="text-center" style={{borderRight: '1px solid white'}}>Regiones</th>
                        <th className="text-center" style={{borderRight: '1px solid white'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" /></th>
                        <th className="text-center" style={{borderRight: '1px solid white'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-2.png")} alt="medalla segundo lugar" /></th>
                        <th className="text-center" style={{borderRight: '1px solid white'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-3.png")} alt="medalla tercer lugar" /></th>
                        <th className="text-center">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {trofeoDepartamentos.length !== 0 ?(
                        trofeoDepartamentos.map((club, indexClub)=>{
                          return <motion.tr key={indexClub}
                          className="text-center"
                          initial={{ scale: 0}}
                          animate={{ scale: animateList ? 0 : 1}}
                          transition={{ duration: 0.5, delay: `0.${indexClub}`, type: 'spring'}}
                          style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexClub}`}}
                          >
                            {indexClub === 0 ? <td style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}><img style={{width: '50px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-trofeo-1.png")} alt="trofeo primer lugar" /></td> : indexClub === 1 ? <td style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}><img style={{width: '50px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-trofeo-2.png")} alt="trofeo segundo lugar" /></td> :  indexClub === 2 ? <td style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}><img style={{width: '50px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-trofeo-3.png")} alt="trofeo tercer lugar" /></td> : <td className={`pt-2 pb-2`} style={{background: 'white', width: '75px', borderRadius: '20px 0 0 0'}}>{indexClub + 1}</td>}
                            <td className="text-start" style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white', cursor: 'pointer'}}>
                              {club.club}
                              <span className="border rounded-5 d-flex m-auto" style={{width: '100%', height: '12px'}}>
                                <span className="d-block text-center text-light" style={{fontSize: '10px', lineHeight: 1, width: `${Math.round((club.oro / trofeoDepartamentos.reduce((acumulador, objeto)=> {return acumulador + objeto.oro}, 0)) * 100)}%`, height: '10px', background: '#D4AF37', borderRadius: '8px 0 0 8px', textShadow: '0 0 2px black'}}>
                                  {Math.round((club.oro / trofeoDepartamentos.reduce((acumulador, objeto)=> {return acumulador + objeto.oro}, 0)) * 100)}%
                                </span>
                                <span className="d-block text-center text-light" style={{fontSize: '10px', lineHeight: 1, width: `${Math.round((club.plata / trofeoDepartamentos.reduce((acumulador, objeto)=> {return acumulador + objeto.plata}, 0)) * 100)}%`, height: '10px', background: '#C0C0C0', textShadow: '0 0 2px black'}}>
                                  {Math.round((club.plata / trofeoDepartamentos.reduce((acumulador, objeto)=> {return acumulador + objeto.plata}, 0)) * 100)}%
                                </span>
                                <span className="d-block text-center text-light" style={{fontSize: '10px', lineHeight: 1, width: `${Math.round((club.bronce / trofeoDepartamentos.reduce((acumulador, objeto)=> {return acumulador + objeto.bronce}, 0)) * 100)}%`, height: '10px', background: '#CD7F32', borderRadius: '0 8px 8px 0', textShadow: '0 0 2px black'}}>
                                  {Math.round((club.bronce / trofeoDepartamentos.reduce((acumulador, objeto)=> {return acumulador + objeto.bronce}, 0)) * 100)}%
                                </span>
                              </span>
                            </td>
                            <td style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{banderas(club.departamento, club.codePais)}</td>
                            <td style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.oro}</td>
                            <td style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.plata}</td>
                            <td style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>{club.bronce}</td>
                            <th style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white', borderRadius: '0 0 20px 0'}}>{club.total}</th>
                          </motion.tr>
                        })
                      ):(
                        <tr>
                          <td colSpan={8} style={{fontSize: '15px', fontFamily: 'Poppins', background: 'white'}}>El torneo aún no empieza.</td>
                        </tr>
                      )
                      }
                    </tbody>
                  </table>
                </div>
              </TabPanel>
            </TabView>
          </TabPanel>
          <TabPanel header="Records" leftIcon='pi pi-stopwatch me-2'>
            {!eventoPagado ? (
              <div className="w-100 alert alert-info alert-warning fade show m-auto p-1 mt-3 shadow" role="alert" style={{ maxWidth: '500px' }}>
                <p className="text-center m-0" style={{lineHeight: 1.2}}>{!usuarioFamilia && 'Ingresa con tu cuenta de Google y p'}{usuarioFamilia && 'P'}or solo COP <b>{valorCOP}</b> accede a resultados y detalles exclusivos del evento. {!evento && <b><br />Elige un evento</b>}</p>
                <hr className="my-1"/>
                {!usuarioFamilia && <Button icon='pi pi-google' className="w-auto p-1 px-2 rounded-3 mx-1" severity="secondary" label="Acceso" size="small" onClick={() => loginGoogle()}></Button>}
                {(evento && usuarioFamilia) && <Button icon='pi pi-wallet' className="w-auto p-1 px-2 rounded-3 mx-1" severity="secondary" label="Wompi" size="small" onClick={() => pagar()}></Button>}
              </div>
            ):(
              <>
                <div className="alert alert-info alert-dismissible fade show text-start mb-0" role="alert">
                  <h4>Récords Oficiales</h4>
                  <p className="mb-0">Los récords corresponden exclusivamente a los mejores tiempos logrados en los eventos organizados por el equipo <b>{datosAdmin.nombre}</b>.</p>
                  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div className='w-100 m-auto flex-fill row row-cols-1 row-cols-sm-2 row-cols-md-4 justify-content-center align-items-start'>
                  {recordsEvento.length !== 0 ? (
                    recordsEvento.map((depor, indexDepor)=>{
                      return <motion.div
                        className={`position-relative card m-2 pt-2 col shadow card-torneo card-crear-torneo`}
                        style={{ width: "22rem", background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)' }}
                        key={indexDepor} 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1, delay: `0.${indexDepor}5` }}
                        id={`card-torneo${indexDepor}`}
                      >
                        <div className="w-100">
                          <div className='d-flex'>
                            <div>
                              {banderas(depor.departamento, depor.codePais)}
                            </div>
                            <p className='m-0 ms-2' style={{color: 'rgba(212, 212, 212, 1)'}}>{depor.departamento}</p>
                          </div>
                          <div className='bg-light rounded-3 px-1 shadow position-relative'>
                            <img className='position-absolute' src={depor.urlPhoto && depor.urlPhoto !== '' ? depor.urlPhoto : depor.genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp')} alt="foto deportista" style={{width: '70px', filter: 'drop-shadow(0 0 2px black) drop-shadow(0 0 1px white)', bottom: '0', right: '0'}}/>
                            <h4 className='card-title mt-1 mb-0 text-start'>{depor.deportista}</h4>
                            <p className='m-0 text-start'>{depor.edad + ' Años'}</p>
                          </div>
                          <p className='m-0 text-start' style={{color: 'rgba(212, 212, 212, 1)'}}>{depor.club}</p>
                          <hr className='m-0 text-light'/>
                          <div>
                            <h5 className='card-subtitle my-1 text-light text-center'>{depor.prueba}</h5>
                            <h6 className='card-subtitle my-1 text-light text-center'>{'Piscina de ' + depor.piscina + ' metros'}</h6>
                          </div>
                          <hr className='m-0 text-light'/>
                          {depor.recordAnterior && (
                            <div>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Evento:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{depor.recordAnterior.evento}</p>
                              </div>
                              <hr className='m-0 text-light'/>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Fecha:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{depor.recordAnterior.fecha}</p>
                              </div>
                              <hr className='m-0 text-light'/>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Puesto:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>#02</p>
                              </div>
                              <hr className='m-0 text-light'/>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Deportista:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{depor.recordAnterior.deportista}</p>
                              </div>
                              <hr className='m-0 text-light'/>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Equipo:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{depor.recordAnterior.club}</p>
                              </div>
                              <hr className='m-0 text-light'/>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Edad:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{depor.recordAnterior.edad + ' Años'}</p>
                              </div>
                              <hr className='m-0 text-light'/>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Record Anterior:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{arreglarTiempoEstandar(depor.recordAnterior.record)}</p>
                              </div>
                              <hr className='m-0 text-light'/>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Diferencia:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{arreglarFormatoTiempo(manejoRendimiento(depor.record, depor.recordAnterior.record))}</p>
                              </div>
                            </div>
                          )}
                          <hr className='m-0'/>
                          <div className='text-center bg-light shadow px-1'>
                            <p className='m-0 fw-bold'>{depor.evento}</p>
                          </div>
                          <hr className='m-0'/>
                          <div className='text-center'>
                            <p className='m-0 text-muted'>{depor.fecha}</p>
                          </div>
                          <hr className='m-0'/>
                          <div className='d-flex justify-content-between bg-light shadow mb-2 px-1'>
                            <h5 className='fw-bold m-0'>Record:</h5>
                            <h5 className='fw-bold m-0'>{arreglarTiempoEstandar(depor.record)}</h5>
                          </div>
                        </div>
                      </motion.div>
                    })
                  ):(
                    <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{duration: 1}}
                    className="w-100"
                    >
                      <div className='p-5 text-center'>
                        <img className='m-auto' style={{width: '230px'}} src={require('../img/img-logo-swimmingt.webp')} alt="logo prowebsports" />
                        <h1>¡Bienvenido!</h1>
                        <p>No tenemos records aún.</p>
                      </div>
                    </motion.div>
                  )}
                </div>
              </>
            )}
          </TabPanel>
          <TabPanel header="Mundial" leftIcon='pi pi-map me-2'>
            {!usuarioFamilia ? (
              <div className="w-100 alert alert-info alert-warning fade show m-auto p-1 mt-3 shadow" role="alert" style={{ maxWidth: '500px' }}>
                <p className="text-center m-0" style={{lineHeight: 1.2}}>Ingresa con una cuenta de Google.</p>
                <hr className="my-1"/>
                <Button icon='pi pi-google' className="w-auto p-1 px-2 rounded-3 mx-1" severity="secondary" label="Acceso" size="small" onClick={() => loginGoogle()}></Button>
              </div>
            ):(
              <TabView>
                <TabPanel header="Femenino" leftIcon='pi pi-user me-2'>
                  <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
                    <span className="p-input-icon-left w-auto">
                      <i className="pi pi-user"/>
                      <InputText
                        type="number"
                        onChange={(e) => setEdadMarcaMundialF(e.target.value === '' ? 0 : e.target.value)}
                        defaultValue={edadMarcaMundialF}
                        placeholder="Edad Minima Femenino"
                      />
                    </span>
                  </div>
                  <Accordion className='m-auto' activeIndex={0} style={{maxWidth: '850px'}}>
                    <AccordionTab header="Pruebas disponibles">
                      <div className="d-flex flex-wrap justify-content-evenly">
                        {pruebasRecords().map((recF, indexRecF)=>{
                          return <div key={indexRecF} className="d-flex align-items-center" style={{width: '180px'}}>
                          <Checkbox inputId={recF} name="pizza" value={recF} onChange={sacarMarcasMundialesFElegidas} checked={opcionesElegidosF.includes(recF)}/>
                          <label htmlFor={recF} className="ml-2">{recF}</label>
                        </div>
                        })}
                      </div>
                    </AccordionTab>
                  </Accordion>
                  <form className='formulario-tablas table-responsive-sm m-auto text-center' style={{maxWidth: '850px'}}>
                    <motion.table style={{margin: '4px', borderRadius: '20px 0', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{duration: 1}}
                    className='w-100 shadow'
                    >
                      <thead className='text-light'>
                        <tr style={{borderBottom: '1px solid white'}}>
                          <th colSpan={7}>MEJOR MARCA TÉCNICA DEL MUNDO - FEMENINO</th>
                        </tr>
                        <tr>
                          <th style={{borderRight: '1px solid white'}}>Psto</th>
                          <th style={{borderRight: '1px solid white'}}>Deportista</th>
                          <th style={{borderRight: '1px solid white'}}>Equipo</th>
                          <th style={{borderRight: '1px solid white'}}>Prueba</th>
                          <th style={{borderRight: '1px solid white'}}>Record</th>
                          <th style={{borderRight: '1px solid white'}}>Tiempo</th>
                        </tr>
                      </thead>
                      <tbody>
                      {mejorMarcaTecnicaF.length !== 0 ?(
                          mejorMarcaTecnicaF.map((marca, indexMarca)=>{
                            return <motion.tr key={indexMarca}
                            initial={{ x: -1000, opacity: 0}} 
                            animate={{ x: animateList ? -1000 : 0.1, opacity: animateList ? 0 : 1}}
                            style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexMarca}`}}
                            transition={{ duration: 0.5, delay: `0.${indexMarca}`, type: 'spring'}}
                            >
                              <td className={`pt-2 pb-2 ${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{indexMarca + 1}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.nombre + ' | ' + marca.edad + ' Años'}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.club}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.prueba}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}><FcApproval />{arreglarTiempoEstandar(marca.mt)}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-tiempos text-light' : 'pe-1 bg-tiempos text-light'}`} style={{fontSize: '15px', fontFamily: 'Poppins'}}><label className="w-100 text-end fw-bold d-flex flex-column"><li style={{fontSize: '12px'}} className={marca.diferencia > 0 ? 'pi pi-arrow-down text-success text-start' : 'pi pi-arrow-up text-danger text-start'}>{arreglarFormatoTiempo(marca.diferencia)}</li>{marca.tiempo}</label></td>
                            </motion.tr>
                          })
                        ):(
                          <tr>
                            <th colSpan={7} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>No hay deportistas aún.</th>
                          </tr>
                        )}
                      </tbody>
                    </motion.table>
                  </form>
                  <p className='pt-2 pb-0 mb-0 text-center' style={{fontSize: '10px'}}>Información extraída de Wikipedia <b>(https://es.wikipedia.org/wiki/Anexo:Plusmarcas_mundiales_de_nataci%C3%B3n)</b>.</p>
                  <p className='pb-2 text-center' style={{fontSize: '10px'}}>Información extraída de Olympics <b>(https://olympics.com/es/noticias/natacion-lista-records-mundiales-pruebas-olimpicas)</b>.</p>
                </TabPanel>
                <TabPanel header="Masculino" leftIcon='pi pi-user me-2'>
                  <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
                    <span className="p-input-icon-left w-auto">
                      <i className="pi pi-user" />
                      <InputText
                        type="number"
                        onChange={(e) => setEdadMarcaMundialM(e.target.value === '' ? 0 : e.target.value)}
                        defaultValue={edadMarcaMundialM}
                        placeholder="Edad Minima Masculino"
                      />
                    </span>
                  </div>
                  <Accordion className='m-auto' activeIndex={0} style={{maxWidth: '850px'}}>
                    <AccordionTab header="Pruebas disponibles">
                      <div className="d-flex flex-wrap justify-content-evenly">
                        {pruebasRecords().map((recM, indexRecM)=>{
                          return <div key={indexRecM} className="d-flex align-items-center" style={{width: '180px'}}>
                          <Checkbox inputId={recM} name="pizza" value={recM} onChange={sacarMarcasMundialesMElegidas} checked={opcionesElegidosM.includes(recM)}/>
                          <label htmlFor={recM} className="ml-2">{recM}</label>
                        </div>
                        })}
                      </div>
                    </AccordionTab>
                  </Accordion>
                  <form className='formulario-tablas table-responsive-sm m-auto text-center' style={{maxWidth: '850px'}}>
                    <motion.table style={{margin: '4px', borderRadius: '20px 0', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{duration: 1}}
                    className='w-100 shadow'
                    >
                      <thead className='text-light'>
                        <tr style={{borderBottom: '1px solid white'}}>
                          <th colSpan={7}>MEJOR MARCA TÉCNICA DEL MUNDO - MASCULINO</th>
                        </tr>
                        <tr>
                          <th style={{borderRight: '1px solid white'}}>Psto</th>
                          <th style={{borderRight: '1px solid white'}}>Deportista</th>
                          <th style={{borderRight: '1px solid white'}}>Equipo</th>
                          <th style={{borderRight: '1px solid white'}}>Prueba</th>
                          <th style={{borderRight: '1px solid white'}}>Record</th>
                          <th style={{borderRight: '1px solid white'}}>Tiempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mejorMarcaTecnicaM.length !== 0 ?(
                          mejorMarcaTecnicaM.map((marca, indexMarca)=>{
                            return <motion.tr key={indexMarca}
                            initial={{ x: -1000, opacity: 0}} 
                            animate={{ x: animateList ? -1000 : 0.1, opacity: animateList ? 0 : 1}}
                            style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexMarca}`}}
                            transition={{ duration: 0.5, delay: `0.${indexMarca}`, type: 'spring'}}
                            >
                              <td className={`pt-2 pb-2 ${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{indexMarca + 1}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.nombre + ' | ' + marca.edad + ' Años'}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.club}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.prueba}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}><FcApproval />{arreglarTiempoEstandar(marca.mt)}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-tiempos text-light' : 'pe-1 bg-tiempos text-light'}`} style={{fontSize: '15px', fontFamily: 'Poppins'}}><label className="w-100 text-end fw-bold d-flex flex-column"><li style={{fontSize: '12px'}} className={marca.diferencia > 0 ? 'pi pi-arrow-down text-success text-start' : 'pi pi-arrow-up text-danger text-start'}>{arreglarFormatoTiempo(marca.diferencia)}</li>{marca.tiempo}</label></td>
                            </motion.tr>
                          })
                        ):(
                          <tr>
                            <th colSpan={7} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>No hay deportistas aún.</th>
                          </tr>
                        )}
                      </tbody>
                    </motion.table>
                  </form>
                  <p className='pt-2 pb-0 mb-0' style={{fontSize: '10px'}}>Información extraída de Wikipedia <b>(https://es.wikipedia.org/wiki/Anexo:Plusmarcas_mundiales_de_nataci%C3%B3n)</b>.</p>
                  <p className='pb-2' style={{fontSize: '10px'}}>Información extraída de Olympics <b>(https://olympics.com/es/noticias/natacion-lista-records-mundiales-pruebas-olimpicas)</b>.</p>
                </TabPanel>
              </TabView>
            )}
          </TabPanel>
          <TabPanel header="Colombia" leftIcon='pi pi-map-marker me-2'>
            {!usuarioFamilia ? (
              <div className="w-100 alert alert-info alert-warning fade show m-auto p-1 mt-3 shadow" role="alert" style={{ maxWidth: '500px' }}>
                <p className="text-center m-0" style={{lineHeight: 1.2}}>Ingresa con una cuenta de Google.</p>
                <hr className="my-1"/>
                <Button icon='pi pi-google' className="w-auto p-1 px-2 rounded-3 mx-1" severity="secondary" label="Acceso" size="small" onClick={() => loginGoogle()}></Button>
              </div>
            ):(
              <TabView>
                <TabPanel header="Femenino" leftIcon='pi pi-user me-2'>
                  <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
                    <span className="p-input-icon-left w-auto">
                        <i className="pi pi-user" />
                        <InputText
                          type="number"
                          onChange={(e) => setEdadMarcaNacionalF(e.target.value === '' ? 0 : e.target.value)}
                          defaultValue={edadMarcaNacionalF}
                          placeholder="Edad Minima Femenino"
                        />
                    </span>
                  </div>
                  <Accordion className='m-auto' activeIndex={0} style={{maxWidth: '850px'}}>
                    <AccordionTab header="Pruebas disponibles">
                      <div className="d-flex flex-wrap justify-content-evenly">
                        {pruebasRecords().map((recF, indexRecF)=>{
                          return <div key={indexRecF} className="d-flex align-items-center" style={{width: '180px'}}>
                          <Checkbox inputId={recF} name="pizza" value={recF} onChange={sacarMarcasNacionalesFElegidas} checked={opcionesNacionalesElegidosF.includes(recF)}/>
                          <label htmlFor={recF} className="ml-2">{recF}</label>
                        </div>
                        })}
                      </div>
                    </AccordionTab>
                  </Accordion>
                  <form className='formulario-tablas table-responsive-sm m-auto text-center' style={{maxWidth: '850px'}}>
                    <motion.table style={{margin: '4px', borderRadius: '20px 0', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{duration: 1}}
                    className='w-100 shadow'
                    >
                      <thead className='text-light'>
                        <tr style={{borderBottom: '1px solid white'}}>
                          <th colSpan={7}>MEJOR MARCA TÉCNICA DE COLOMBIA - FEMENINO</th>
                        </tr>
                        <tr>
                          <th style={{borderRight: '1px solid white'}}>Psto</th>
                          <th style={{borderRight: '1px solid white'}}>Deportista</th>
                          <th style={{borderRight: '1px solid white'}}>Equipo</th>
                          <th style={{borderRight: '1px solid white'}}>Prueba</th>
                          <th style={{borderRight: '1px solid white'}}>Record</th>
                          <th style={{borderRight: '1px solid white'}}>Tiempo</th>
                        </tr>
                      </thead>
                      <tbody>
                      {mejorMarcaTecnicaNacionalF.length !== 0 ?(
                          mejorMarcaTecnicaNacionalF.map((marca, indexMarca)=>{
                            return <motion.tr key={indexMarca}
                            initial={{ x: -1000, opacity: 0}} 
                            animate={{ x: animateList ? -1000 : 0.1, opacity: animateList ? 0 : 1}}
                            style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexMarca}`}}
                            transition={{ duration: 0.5, delay: `0.${indexMarca}`, type: 'spring'}}
                            >
                              <td className={`pt-2 pb-2 ${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{indexMarca + 1}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.nombre + ' | ' + marca.edad + ' Años'}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.club}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.prueba}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}><FcApproval />{arreglarTiempoEstandar(marca.mt)}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-tiempos text-light' : 'pe-1 bg-tiempos text-light'}`} style={{fontSize: '15px', fontFamily: 'Poppins'}}><label className="w-100 text-end fw-bold d-flex flex-column"><li style={{fontSize: '12px'}} className={marca.diferencia > 0 ? 'pi pi-arrow-down text-success text-start' : 'pi pi-arrow-up text-danger text-start'}>{arreglarFormatoTiempo(marca.diferencia)}</li>{marca.tiempo}</label></td>
                            </motion.tr>
                          })
                        ):(
                          <tr>
                            <th colSpan={7} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>No hay deportistas aún.</th>
                          </tr>
                        )}
                      </tbody>
                    </motion.table>
                  </form>
                  <p className='p-2 text-center' style={{fontSize: '10px'}}>Información extraída de la Federación Colombiana de Natación <b>(https://fecna.com.co/)</b>.</p>
                </TabPanel>
                <TabPanel header="Masculino" leftIcon='pi pi-user me-2'>
                  <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
                    <span className="p-input-icon-left w-auto">
                      <i className="pi pi-user" />
                      <InputText
                        type="number"
                        onChange={(e) => setEdadMarcaNacionalM(e.target.value === '' ? 0 : e.target.value)}
                        defaultValue={edadMarcaNacionalM}
                        placeholder="Edad Minima Masculino"
                      />
                    </span>
                  </div>
                  <Accordion className='m-auto' activeIndex={0} style={{maxWidth: '850px'}}>
                    <AccordionTab header="Pruebas disponibles">
                      <div className="d-flex flex-wrap justify-content-evenly">
                        {pruebasRecords().map((recM, indexRecM)=>{
                          return <div key={indexRecM} className="d-flex align-items-center" style={{width: '180px'}}>
                          <Checkbox inputId={recM} name="pizza" value={recM} onChange={sacarMarcasNacionalesMElegidas} checked={opcionesNacionalesElegidosM.includes(recM)}/>
                          <label htmlFor={recM} className="ml-2">{recM}</label>
                        </div>
                        })}
                      </div>
                    </AccordionTab>
                  </Accordion>
                  <form className='formulario-tablas table-responsive-sm m-auto text-center' style={{maxWidth: '850px'}}>
                    <motion.table style={{margin: '4px', borderRadius: '20px 0', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{duration: 1}}
                    className='w-100 shadow'
                    >
                      <thead className='text-light'>
                        <tr style={{borderBottom: '1px solid white'}}>
                          <th colSpan={7}>MEJOR MARCA TÉCNICA DE COLOMBIA - MASCULINO</th>
                        </tr>
                        <tr>
                          <th style={{borderRight: '1px solid white'}}>Psto</th>
                          <th style={{borderRight: '1px solid white'}}>Deportista</th>
                          <th style={{borderRight: '1px solid white'}}>Equipo</th>
                          <th style={{borderRight: '1px solid white'}}>Prueba</th>
                          <th style={{borderRight: '1px solid white'}}>Record</th>
                          <th style={{borderRight: '1px solid white'}}>Tiempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mejorMarcaTecnicaNacionalM.length !== 0 ?(
                          mejorMarcaTecnicaNacionalM.map((marca, indexMarca)=>{
                            return <motion.tr key={indexMarca}
                            initial={{ x: -1000, opacity: 0}} 
                            animate={{ x: animateList ? -1000 : 0.1, opacity: animateList ? 0 : 1}}
                            style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexMarca}`}}
                            transition={{ duration: 0.5, delay: `0.${indexMarca}`, type: 'spring'}}
                            >
                              <td className={`pt-2 pb-2 ${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{indexMarca + 1}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.nombre + ' | ' + marca.edad + ' Años'}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.club}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{marca.prueba}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-info text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}><FcApproval />{arreglarTiempoEstandar(marca.mt)}</td>
                              <td className={`${marca.identificacion === identidad || marca.club === nombreClub.name ? 'bg-tiempos text-light' : 'pe-1 bg-tiempos text-light'}`} style={{fontSize: '15px', fontFamily: 'Poppins'}}><label className="w-100 text-end fw-bold d-flex flex-column"><li style={{fontSize: '12px'}} className={marca.diferencia > 0 ? 'pi pi-arrow-down text-success text-start' : 'pi pi-arrow-up text-danger text-start'}>{arreglarFormatoTiempo(marca.diferencia)}</li>{marca.tiempo}</label></td>
                            </motion.tr>
                          })
                        ):(
                          <tr>
                            <th colSpan={7} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>No hay deportistas aún.</th>
                          </tr>
                        )}
                      </tbody>
                    </motion.table>
                  </form>
                  <p className='p-2 text-center' style={{fontSize: '10px'}}>Información extraída de la Federación Colombiana de Natación <b>(https://fecna.com.co/)</b>.</p>
                </TabPanel>
              </TabView>
            )}
          </TabPanel>
          <TabPanel header={`${opiniones.length} Opiniones`} leftIcon='pi pi-star-fill me-2'>
            {opiniones.length !== 0 ? (
              <>
                <h3 className="text-center mt-2" style={{lineHeight: "1", fontFamily: "Winky Sans"}}>{obtenerMensajeExperiencia(calificacionGeneral)}</h3>
                <div className="d-flex align-items-center justify-content-center mt-1">
                  <Rating value={calificacionGeneral} disabled cancel={false}/>
                </div>
                <h4 className="text-center mt-1" style={{lineHeight: "1", fontFamily: "Winky Sans"}}>{calificacionGeneral + ' de ' + opiniones.length + ' opiniones'}</h4>
                <hr />
              </>
            ):(
              <></>
            )}
            <div className="mt-1 mb-3 m-auto" style={{maxWidth: '1000px'}}>
              {opiniones.length !== 0 ?(
                opiniones.map((op, indexOp)=>{
                  return <div className="mt-1 px-1" key={indexOp}>
                    <div className="d-flex align-items-center mb-1">
                      <Avatar className="me-1" label={op.nombre ? op.nombre[0] : 'A'} shape="circle"/>
                      <div style={{lineHeight: 0.8}}>
                        <div className="d-flex align-items-center">
                          <p className="m-0" style={{fontFamily: 'Winky Sans'}}>{op.nombre ? op.nombre : 'Anónimo'}</p>
                          <Rating className="estre-opiniones mx-2" value={op.estrellas} disabled cancel={false}/>
                          {(usuarioFamilia?.nombre === op.nombre && op.nombre) && (
                            <i title='Eliminar Opinión' className='pi pi-times-circle text-danger' style={{cursor: 'pointer'}} onClick={() => eliminarOpinion(evento, op.id)}></i>
                          )}
                        </div>
                        <span className="text-muted fw-bold" style={{fontSize: "12px"}}>{arreglarFecha(op.fecha)}</span>
                      </div>
                    </div>
                    {op.opinio !== '' && (<label style={{lineHeight: "1.2", fontSize: "15px"}}>{op.opinion}</label>)} 
                    <hr className="m-0"/>
                  </div>
                })
              ):(
                <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{duration: 1}}
                >
                  <div className='p-5 text-center'>
                    <img className='m-auto' style={{width: '230px'}} src={require('../img/img-logo-swimmingt.webp')} alt="logo prowebsports" />
                    <h1>¡Bienvenido!</h1>
                    <p>No tenemos opiniones aún.</p>
                  </div>
                </motion.div>
              )}
            </div>
          </TabPanel>
        </TabView>
      </Dialog>
      <Sidebar header={<span className="fw-bold">BOLT RESULTADOS</span>} visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} className="bolt">
        <div className="w-100 h-100 position-relative">
          <div style={{ maxHeight: '80%', overflowY: 'auto'}}>
            {messages.map((mess, indexMess)=>{
              return <motion.div key={indexMess} className='d-flex'
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{duration: 1, delay: `0.${indexMess}`}}
              >
                {indexMess % 2 !== 0 ? (
                  <Avatar image={require('../img/pwsmascota-izquierda.png')} shape="circle" size='small'/>
                ):(
                  <></>
                )}
                <p
                className={`${mess?.parts[0].text !== '' ? 'p-1' : ''} m-0 ${indexMess % 2 === 0 ? 'ms-auto bolt-primary' : 'me-auto bolt-danger'} text-start mb-1 shadow-sm`} 
                style={{borderRadius: '10px', width: '85%', lineHeight: 1.1}}>{mess?.parts[0].text}</p>
              </motion.div>
            })}
            <span
            className='d-flex justify-content-start mt-2' style={{width: '85%'}}>
              <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: messageEspera ? 1 : 0 }}
              >Escribiendo...</motion.p>
            </span>
          </div> 
          {!eventoPagado ? (
            <div className="w-100 alert alert-info alert-warning fade show m-auto p-1 mt-3 shadow" role="alert" style={{ maxWidth: '500px' }}>
              <p className="text-center m-0" style={{lineHeight: 1.2}}>{!usuarioFamilia && 'Ingresa con tu cuenta de Google y p'}{usuarioFamilia && 'P'}or solo COP <b>{valorCOP}</b> accede a resultados y detalles exclusivos del evento. {!evento && <b><br />Elige un evento</b>}</p>
              <hr className="my-1"/>
              {!usuarioFamilia && <Button icon='pi pi-google' className="w-auto p-1 px-2 rounded-3 mx-1" severity="secondary" label="Acceso" size="small" onClick={() => loginGoogle()}></Button>}
              {(evento && usuarioFamilia) && <Button icon='pi pi-wallet' className="w-auto p-1 px-2 rounded-3 mx-1" severity="secondary" label="Wompi" size="small" onClick={() => pagar()}></Button>}
            </div>
          ):(
            <div className="w-100 position-absolute bottom-0">
              <div className="d-flex align-items-end">
                <textarea type='text' id="preguntame" className="form-control" rows='4' placeholder="¿Qué te gustaría saber sobre tus resultados, tiempos, medallas, trofeos o equipos? Ej: ¿Cuántas medallas gané? / ¿Qué tiempo hice en 50m libre?"></textarea>
                <Button icon='pi pi-send' className="rounded-3" severity="success" onClick={() => handleSend()}/>
              </div>
              <footer className="text-muted" style={{fontSize: "12px"}}>Bolt hace su mejor esfuerzo, pero puede cometer errores. ¡No olvides revisar la información!</footer>
            </div>
          )}
        </div>
      </Sidebar>
      <Dialog visible={dialogHistorialEquipo} style={{ width: '50em' }} breakpoints={{ '700px': '100%' }} header="Historial Deportivo" modal className="p-fluid" onHide={() => setDialogHistorialEquipo(false)}>
        <div className="field">
          {historialEquipo ?(
            historialEquipo?.deportistas.map((historialDeportista, indexHistorial)=>{
              return <div key={indexHistorial} className={`position-relative card p-1 mb-1 col shadow card-torneo`} style={{background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}>
              <div className="w-100">
                <div className='d-flex justify-content-between'>
                  <div className='d-flex'>
                    <div>
                      {banderas(historialDeportista?.departamento, historialDeportista?.codePais)}
                    </div>
                    <p className='m-0 ms-2' style={{color: 'rgba(212, 212, 212, 1)'}}>{historialDeportista?.departamento}</p>
                  </div>
                  <p className='m-0' style={{color: 'rgba(212, 212, 212, 1)'}}>PWS</p>
                </div>
                <div className='bg-light rounded-3 px-1 shadow position-relative'>
                  <Avatar className='position-absolute flex align-items-center justify-content-center mr-2' size='large' image={historialDeportista?.urlPhotoEq !== '' ? historialDeportista?.urlPhotoEq : null} label={(historialDeportista?.urlPhotoEq === '') && (historialDeportista?.nombreclub[0] + historialDeportista?.nombreclub[1])} style={{bottom: '0', right: '90px'}}/>
                  <img className='position-absolute' src={historialDeportista.urlPhoto && historialDeportista.urlPhoto !== '' ? historialDeportista.urlPhoto : historialDeportista.genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp')} alt="foto deportista" style={{width: '80px', filter: 'drop-shadow(0 0 2px black) drop-shadow(0 0 1px white)', bottom: '0', right: '0'}}/>
                  <h4 className='card-title mt-1 mb-0 text-start'>{historialDeportista.nombre}</h4>
                  <p className='m-0 text-start'><Tag severity={historialDeportista.verificado === 'Verificado' ? 'primary' : 'danger'} value={historialDeportista.verificado === 'Verificado' ? historialDeportista.edad + ' Años Verificado' : historialDeportista.edad + ' Años No Verificado'}></Tag></p>
                  <div className="d-flex justify-content-between">
                    <p className='m-0'>{historialDeportista.genero}</p>
                  </div>
                </div>
                <p className='m-0 text-start' style={{color: 'rgba(212, 212, 212, 1)'}}>{historialDeportista.nombreclub}</p>
                <p className='card-subtitle text-light'>{(historialDeportista.genero === 'Masculino' ? '(M) ' : '(F) ') + historialDeportista?.categoria + ' Años ' + (historialDeportista?.genero === 'Masculino' ? 'M' : 'F')}</p>
                <hr className='m-0 text-light'/>
                {historialDeportista.pruebas.length !== 0 ?(
                  historialDeportista.pruebas.map((prue, indexPrue)=>{
                    return <div key={indexPrue}>
                      <div className='d-flex justify-content-center align-items-center' data-bs-toggle="collapse" href={`#collapseExample${indexPrue}${indexHistorial}${Math.round(prue.id)}`} role='button' aria-expanded="false" aria-controls={`collapseExample${indexPrue}${indexHistorial}${Math.round(prue.id)}`}>
                        <div className="text-center w-100">
                          <div className="d-flex justify-content-between">
                            <p className='m-0' style={{color: 'rgba(212, 212, 212, 1)'}}>{'Prueba #' + (prue.nPrueba)}</p>
                            <p className='m-0' style={{color: 'rgba(212, 212, 212, 1)'}}>{prue.prueba}</p>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <p className='m-0 text-light'>{'Puesto #' + prue.puesto}{prue.puesto === 1 ? <img style={{width: '25px'}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" />: prue.puesto === 2 ? <img style={{width: '25px'}} src={require("../img/icon-medalla-2.png")} alt="medalla segundo lugar" /> :  prue.puesto === 3 ? <img style={{width: '25px'}} src={require("../img/icon-medalla-3.png")} alt="medalla tercer lugar" /> : ''}</p>
                            <p className='m-0 text-light'>{prue.tiempo === '0:0:0' ? 'NSP' : prue.tiempo === '61:0:0' ? 'DSC' : <label className="w-100 fw-bold d-flex flex-column text-end"><li style={{fontSize: '13px', textShadow: '0 0 8px black'}} className={manejoRendimiento(prue.record, prue.tiempo === '61:0:0' ? '0:0:0' : prue.tiempo) >= 0 ? 'pi pi-arrow-down text-success text-start' : 'pi pi-arrow-up text-danger text-start'}>{arreglarFormatoTiempo(manejoRendimiento(prue.record, prue.tiempo === '61:0:0' ? '0:0:0' : prue.tiempo))}</li>{arreglarTiempoEstandar(prue.tiempo)}</label>}</p>
                          </div>
                        </div>
                      </div>
                      <hr className='m-0 text-light'/>
                      <div className='collapse px-2' id={`collapseExample${indexPrue}${indexHistorial}${Math.round(prue.id)}`}>
                        <div className='d-flex justify-content-between'>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Tiempo Inscrito:</p>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{arreglarTiempoEstandar(prue.record)}</p>
                        </div>
                        <hr className='m-0 text-light'/>
                        <div className='d-flex justify-content-between'>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>World Aquatics:</p>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{prue.tiempo !== '61:0:0' ? prue.tiempo !== '0:0:0' ? prue.puntos : '0' : '0' }</p>
                        </div>
                        <hr className='m-0 text-light'/>
                        <div className='d-flex justify-content-between'>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Rendimiento Técnico:</p>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{prue.tiempo !== '61:0:0' ? prue.tiempo !== '0:0:0' ? prue.puntosWA : '0' : '0' }</p>
                        </div>
                      </div>
                      <hr className='m-0 text-light'/>
                    </div>
                  })
                ):(
                  <></>
                )}
              </div>
            </div>
            })
          ):(
            <></>
          )}
        </div>
      </Dialog>
      <Dialog visible={dialogHistorial} style={{ width: '50em' }} breakpoints={{ '700px': '100%' }} header="Historial Deportivo" modal className="p-fluid" onHide={() => setDialogHistorial(false)}>
        <div className="field">
          {historialDeportista ?(
            <div className={`position-relative card p-1 col shadow card-torneo`} style={{background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}>
              <div className="w-100">
                <div className='d-flex justify-content-between'>
                  <div className='d-flex'>
                    <div>
                      {banderas(historialDeportista?.departamento, historialDeportista?.codePais)}
                    </div>
                    <p className='m-0 ms-2' style={{color: 'rgba(212, 212, 212, 1)'}}>{historialDeportista?.departamento}</p>
                  </div>
                  <p className='m-0' style={{color: 'rgba(212, 212, 212, 1)'}}>PWS</p>
                </div>
                <div className='bg-light rounded-3 px-1 shadow position-relative'>
                  <Avatar className='position-absolute flex align-items-center justify-content-center mr-2' size='large' image={historialDeportista?.urlPhotoEq !== '' ? historialDeportista?.urlPhotoEq : null} label={(historialDeportista?.urlPhotoEq === '') && (historialDeportista?.nombreclub[0] + historialDeportista?.nombreclub[1])} style={{bottom: '0', right: '90px'}}/>
                  <img className='position-absolute' src={historialDeportista?.urlPhoto && historialDeportista?.urlPhoto !== '' ? historialDeportista?.urlPhoto : historialDeportista?.genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp')} alt="foto deportista" style={{width: '80px', filter: 'drop-shadow(0 0 2px black) drop-shadow(0 0 1px white)', bottom: '0', right: '0'}}/>
                  <h4 className='card-title mt-1 mb-0 text-start'>{historialDeportista?.nombre}</h4>
                  <p className='m-0 text-start'><Tag severity={historialDeportista?.verificado === 'Verificado' ? 'primary' : 'danger'} value={historialDeportista?.verificado === 'Verificado' ? historialDeportista?.edad + ' Años Verificado' : historialDeportista?.edad + ' Años No Verificado'}></Tag></p>
                  <div className="d-flex justify-content-between">
                    <p className='m-0'>{historialDeportista?.genero}</p>
                  </div>
                </div>
                <p className='m-0 text-start' style={{color: 'rgba(212, 212, 212, 1)'}}>{historialDeportista?.nombreclub}</p>
                <p className='card-subtitle text-light'>{(historialDeportista?.genero === 'Masculino' ? '(M) ' : '(F) ') + historialDeportista?.categoria + ' Años ' + (historialDeportista?.genero === 'Masculino' ? 'M' : 'F')}</p>
                <hr className='m-0 text-light'/>
                {historialDeportista?.pruebas.length !== 0 ?(
                  historialDeportista?.pruebas.map((prue, indexPrue)=>{
                    return <div key={indexPrue}>
                      <div className='d-flex justify-content-center align-items-center' data-bs-toggle="collapse" href={`#collapseExample${indexPrue}${Math.round(prue.id)}`} role='button' aria-expanded="false" aria-controls={`collapseExample${indexPrue}${Math.round(prue.id)}`}>
                        <div className="text-center w-100">
                          <div className="d-flex justify-content-between">
                            <p className='m-0' style={{color: 'rgba(212, 212, 212, 1)'}}>{'Prueba #' + (prue.nPrueba)}</p>
                            <p className='m-0' style={{color: 'rgba(212, 212, 212, 1)'}}>{prue.prueba}</p>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <p className='m-0 text-light'>{'Puesto #' + prue.puesto}{prue.puesto === 1 ? <img style={{width: '25px'}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" />: prue.puesto === 2 ? <img style={{width: '25px'}} src={require("../img/icon-medalla-2.png")} alt="medalla segundo lugar" /> :  prue.puesto === 3 ? <img style={{width: '25px'}} src={require("../img/icon-medalla-3.png")} alt="medalla tercer lugar" /> : ''}</p>
                            <p className='m-0 text-light'>{prue.tiempo === '0:0:0' ? 'NSP' : prue.tiempo === '61:0:0' ? 'DSC' : <label className="w-100 fw-bold d-flex flex-column text-end"><li style={{fontSize: '13px', textShadow: '0 0 8px black'}} className={manejoRendimiento(prue.record, prue.tiempo === '61:0:0' ? '0:0:0' : prue.tiempo) >= 0 ? 'pi pi-arrow-down text-success text-start' : 'pi pi-arrow-up text-danger text-start'}>{arreglarFormatoTiempo(manejoRendimiento(prue.record, prue.tiempo === '61:0:0' ? '0:0:0' : prue.tiempo))}</li>{arreglarTiempoEstandar(prue.tiempo)}</label>}</p>
                          </div>
                        </div>
                      </div>
                      <hr className='m-0 text-light'/>
                      <div className='collapse px-2' id={`collapseExample${indexPrue}${Math.round(prue.id)}`}>
                        <div className='d-flex justify-content-between'>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Tiempo Inscrito:</p>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{arreglarTiempoEstandar(prue.record)}</p>
                        </div>
                        <hr className='m-0 text-light'/>
                        <div className='d-flex justify-content-between'>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>World Aquatics:</p>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{prue.tiempo !== '61:0:0' ? prue.tiempo !== '0:0:0' ? prue.puntos : '0' : '0' }</p>
                        </div>
                        <hr className='m-0 text-light'/>
                        <div className='d-flex justify-content-between'>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Rendimiento Técnico:</p>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{prue.tiempo !== '61:0:0' ? prue.tiempo !== '0:0:0' ? prue.puntosWA : '0' : '0' }</p>
                        </div>
                      </div>
                      <hr className='m-0 text-light'/>
                    </div>
                  })
                ):(
                  <></>
                )}
              </div>
            </div>
          ):(
            <></>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default Sesion;